<template>
    <v-app>
        <mainMenu></mainMenu>
        <v-container>
            <v-layout>
                <v-flex>
                    <v-btn @click="upAccChart()">upAccountchart</v-btn>
                    <v-btn @click="upProCode()">upProduct</v-btn>
                    <!-- <v-btn @click="addGl">เพิ่ม Gl</v-btn> -->
                    <!-- <v-btn @click="test"></v-btn> -->
                    <v-btn @click="searchBalance()">เริ่มเลขบัญชีของปีใหม่</v-btn>
                    <v-btn @click="uploadCust">สร้างตารางสรุปยอดขายของลูกค้า</v-btn>
                </v-flex>

            </v-layout>
            <!-- <v-layout v-for="(item,i) in listProd" :key="i">
                <v-flex>{{i+1}}</v-flex>
                <v-flex v-model="item.Code">{{item.Code}}</v-flex>
                <v-flex v-model="item.NameThai">{{item.NameThai}}</v-flex>
                <v-flex v-model="item.NameMM">{{item.NameMM}}</v-flex>
                <v-flex v-model="item.PriceThai">{{item.PriceThai}}</v-flex>
                <v-flex v-model="item.PriceMM">{{item.PriceMM}}</v-flex>
            </v-layout> -->
            <v-layout v-for="(item,i) in detail" :key="i">
                <v-flex>{{i+1}}</v-flex>
                <v-flex v-model="item.accId">{{item.accId}}</v-flex>
                <v-flex v-model="item.accName">{{item.accName}}</v-flex>
            </v-layout>
        </v-container>
    </v-app>
</template>

<script>
import {db} from '@/firebase'
import mainMenu from '@/components/mainMenu.vue'
export default {
    components:{
        mainMenu
    },
    data(){
        return{
            detail: [],
            listProd: [
                        {
                            "Code": "AC-BE035-5",
                            "NameThai": "แผ่นเหล็กพิงหัวเตียง",
                            "NameMM": "Beding Plate",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-BE035-6",
                            "NameThai": "อะไหล่คานหัวเตียง",
                            "NameMM": "Beding Beam",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-BW01-7",
                            "NameThai": "แผ่นกั้นกลาง BW02",
                            "NameMM": "Center Plate",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-BW01-8",
                            "NameThai": "บานทึบซ้าย BW-01",
                            "NameMM": "Left Opac Sliding Door  (BW-01)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-BW02-2",
                            "NameThai": "หน้าบาน BW-02 บานซ้าย ทึบ",
                            "NameMM": "Left Door - BW-02",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-BW04-9",
                            "NameThai": "หน้าบาน BW-04 บานขวา กระจกเงา",
                            "NameMM": "Right Door - BW-04",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-DCL2K-1",
                            "NameThai": "ตู้2บานประตูมือจับ DCL KD",
                            "NameMM": "2 Doors Cabinet -L handle lock KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-DCL2K-2",
                            "NameThai": "บานประตู มือจับเขาควาย ข้างซ้าย  KD",
                            "NameMM": "Left Doors Cabinet -L handle lock KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-DCL2K-3",
                            "NameThai": "บานประตู มือจับเขาควาย  ข้าง ขวา KD",
                            "NameMM": "Right Doors Cabinet -L handle lock KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-DCR2K-2",
                            "NameThai": "บานประตู มือจับฝัง  ข้าง ซ้าย KD",
                            "NameMM": "Left Doors Cabinet -R handle lock KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-DCR2K-3",
                            "NameThai": "บานประตู มือจับฝัง  ข้าง ขวา KD",
                            "NameMM": "Right Doors Cabinet -R handle lock KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-LT004-1",
                            "NameThai": "โครง LT-004",
                            "NameMM": "LT-004 /Frame",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-LT004-2",
                            "NameThai": "หน้าบาน LT-004",
                            "NameMM": "LT-004 /Door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-LT004K-1",
                            "NameThai": "โครงตุ้ LT-004K",
                            "NameMM": "LT-004K /Body part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-LT004K-7",
                            "NameThai": "แผ่นชั้น LT-004K",
                            "NameMM": "LT-004K /Shelf",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-MAX051K-1",
                            "NameThai": "โครงตุ้ MAX-051K",
                            "NameMM": "MAX-051K /Body",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-MAX051K-7",
                            "NameThai": "แผ่นชั้น MAX-051K",
                            "NameMM": "MAX-051K /Shelf",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-PT110-3",
                            "NameThai": "คิ้วหน้าโต๊ะ PT-110",
                            "NameMM": "Edge PT-110",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-PW03-9",
                            "NameThai": "ขารอง PW-03",
                            "NameMM": "BASE-PW-03",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-SDC04-2",
                            "NameThai": "หน้าบาน SDC-04  ซ้าย",
                            "NameMM": "SDC-04 /Left door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-SDC04-3",
                            "NameThai": "หน้าบาน SDC-04  ขวา",
                            "NameMM": "SDC-04 /Right door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-SDW18/I-2",
                            "NameThai": "หน้าบาน SDW18/I ซ้าย",
                            "NameMM": "SDW-18/I /Left door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-SDW18/I-3",
                            "NameThai": "หน้าบาน SDW18/I ขวา",
                            "NameMM": "SDW-18/I /Right door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-SGD18-2",
                            "NameThai": "หน้าบาน SGD18 กระจกใส ซ้าย",
                            "NameMM": "SGD-18 /Left door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-SGD18-3",
                            "NameThai": "หน้าบาน SGD18 กระจกใส ขวา",
                            "NameMM": "SGD-18 /Right door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-SGD3-2",
                            "NameThai": "บานประตู SGD3 ซ้าย",
                            "NameMM": "SGD-3 /Left door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-SGD3-3",
                            "NameThai": "บานประตู SGD3 ขวา",
                            "NameMM": "SGD-3 /Right door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-SGD3K-1",
                            "NameThai": "โครง SGD3K",
                            "NameMM": "SGD-3 /Body",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-SGD4-2",
                            "NameThai": "บานประตู SGD4 ซ้าย",
                            "NameMM": "SGD-4 /Left door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-SGD4-3",
                            "NameThai": "บานประตู SGD4 ขวา",
                            "NameMM": "SGD-4 /Right door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-SGW18-2",
                            "NameThai": "หน้าบาน SGW18 กระจกใส ซ้าย",
                            "NameMM": "SGW-18 /Left door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-SGW18-3",
                            "NameThai": "หน้าบาน SGW18 กระจกใส ขวา",
                            "NameMM": "SGW-18 /Right door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-SHF-WD-2",
                            "NameThai": "แผ่นชั้น WD-05 ,WD-02",
                            "NameMM": "Shelft -  WD-05 , WD-02",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-SOD18-2",
                            "NameThai": "หน้าบาน SOD18 ซ้าย",
                            "NameMM": "SOD-18 /Left door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-SOD18-3",
                            "NameThai": "หน้าบาน SOD18 ขวา",
                            "NameMM": "SOD-18 /Right door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-SOD3-2",
                            "NameThai": "บานประตู SOD3 ซ้าย",
                            "NameMM": "SOD-3 /Left door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-SOD3-3",
                            "NameThai": "บานประตู SOD3 ขวา",
                            "NameMM": "SOD-3 /Right door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-SOD4-2",
                            "NameThai": "บานประตู SOD4 ซ้าย",
                            "NameMM": "SOD-4 /Left door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-SOD4-3",
                            "NameThai": "บานประตู SOD4 ขวา",
                            "NameMM": "SOD-4 /Right door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-ST-2654C/B",
                            "NameThai": "Box ซ้าย ST",
                            "NameMM": "Left Box ST",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-ST-3060C/T",
                            "NameThai": "หน้าโต๊ะ ST-3060C",
                            "NameMM": "TOP ST-3060C",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-UNI1-1",
                            "NameThai": "โครงตู้ UNI-1",
                            "NameMM": "Frame UNI-1",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-USC3M-2",
                            "NameThai": "บานประตู USC-3/M ซ้าย",
                            "NameMM": "Left Door USC-3/M",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-USC3M-3",
                            "NameThai": "บานประตู USC-3/M ขวา",
                            "NameMM": "Right Door USC-3/M",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AC-WD05-H",
                            "NameThai": "มือจับ WD-05",
                            "NameMM": "WD-05  Handle",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AN-01",
                            "NameThai": "ตู้รองเท้า 16คู่",
                            "NameMM": "Shoe Cabinet 16pairs",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "AN-02",
                            "NameThai": "ตู้รองเท้า 32คู่",
                            "NameMM": "Shoe Cabinet 32pairs",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "B-18",
                            "NameThai": "ฐานตู้บานเลื่อนสูง",
                            "NameMM": "Base for SGD-18",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "B-3",
                            "NameThai": "ฐานตู้บานเลื่อน 3ฟุต",
                            "NameMM": "Base for SGD-3",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "B-3K",
                            "NameThai": "ฐานตู้บานเลื่อน ขนาด 3ฟุตKD",
                            "NameMM": "Base for SGD-3 KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "B-4",
                            "NameThai": "ฐานตู้บานเลื่อน 4ฟุต",
                            "NameMM": "Base for SGD-4",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "B-4K",
                            "NameThai": "ฐานตู้บานเลื่อน ขนาด 4ฟุตKD",
                            "NameMM": "Base for SGD-4KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "B-5",
                            "NameThai": "ฐานตู้บานเลื่อน 5ฟุต",
                            "NameMM": "Base for SGD-5",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "B-5K",
                            "NameThai": "ฐานตู้บานเลื่อน ขนาด 5ฟุตKD",
                            "NameMM": "Base for SGD-5KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BE-035(S)",
                            "NameThai": "เตียงเหล็ก 3.5 ฟุุต",
                            "NameMM": "Steel Bed 3.5ft(S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BE-035/B",
                            "NameThai": "เหล็กคานระแนง 3.5ฟุต",
                            "NameMM": "Steel bed 3.5ft-body part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BE-035/F1",
                            "NameThai": "เหล็กข้างเตียง ซ้าย/ขวา",
                            "NameMM": "Steel bed 3.5ft-frame L/R part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BE-035/F2",
                            "NameThai": "เหล็กหัวเตียง+ท้ายเตียง",
                            "NameMM": "Steel bed 3.5ft-front part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BE-035/H",
                            "NameThai": "เหล็กแผ่นพิงหัวเตียง / คานหัวเตียง",
                            "NameMM": "Steel bed 3.5ft-head part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BE-050(S)",
                            "NameThai": "เตียงเหล็ก 5 ฟุุต",
                            "NameMM": "Steel Bed 5ft(S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BE-050/B",
                            "NameThai": "เหล็กคานระแนง 5ฟุต",
                            "NameMM": "Steel bed 5ft-body part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BE-050/F1",
                            "NameThai": "เหล็กข้างเตียง ซ้าย/ขวา",
                            "NameMM": "Steel bed 5ft-frame L/R part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BE-050/F2",
                            "NameThai": "เหล็กหัวเตียง+ท้ายเตียง",
                            "NameMM": "Steel bed 5ft-front part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BE-050/H",
                            "NameThai": "เหล็กแผ่นพิงหัวเตียง / คานหัวเตียง",
                            "NameMM": "Steel bed 5ft-head part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BE-060(S)",
                            "NameThai": "เตียงเหล็ก 6 ฟุุต",
                            "NameMM": "Steel Bed 6ft(S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BE-060/B",
                            "NameThai": "เหล็กคานระแนง 6ฟุต",
                            "NameMM": "Steel bed 6ft-body part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BE-060/F1",
                            "NameThai": "เหล็กข้างเตียง ซ้าย/ขวา",
                            "NameMM": "Steel bed 6ft-frame L/R part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BE-060/F2",
                            "NameThai": "เหล็กหัวเตียง+ท้ายเตียง",
                            "NameMM": "Steel bed 6ft-front part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BE-060/H",
                            "NameThai": "เหล็กแผ่นพิงหัวเตียง / คานหัวเตียง",
                            "NameMM": "Steel bed 6ft-head part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-12/B-K",
                            "NameThai": "ตู้เสื้อผ้าเด็กบานเปิด ลายหมี KD",
                            "NameMM": "KIDS Wardrobe KD - Bear",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-120/M",
                            "NameThai": "โต๊ะทำงาน 4ฟุต 3ลิ้นชัก vio- Modesty",
                            "NameMM": "Working Desk  4FT 3drawers VIO -Modesty part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-120/MB",
                            "NameThai": "โต๊ะทำงาน 4ฟุต 3ลิ้นชัก มีถาดคีย์บอร์ด vio- Modesty",
                            "NameMM": "Working Desk  4FT 3drawers+KB VIO -Modesty part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-120/T",
                            "NameThai": "โต๊ะทำงาน 4ฟุต 3ลิ้นชัก vio- Top",
                            "NameMM": "Working Desk  4FT 3drawers VIO -Top part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-123",
                            "NameThai": "โต๊ะทำงาน 4ฟุต 3ลิ้นชัก vio",
                            "NameMM": "Working Desk  4FT 3drawers VIO",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-123(S)",
                            "NameThai": "โต๊ะทำงาน 4ฟุต 3ลิ้นชัก vio (KD)",
                            "NameMM": "Working Desk  4FT 3drawers VIO -Set",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-123/Box",
                            "NameThai": "โต๊ะทำงาน 4ฟุต 3ลิ้นชัก vio- Box",
                            "NameMM": "Working Desk  4FT 3drawers VIO -Box part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-1319",
                            "NameThai": "ตู้เก็บเอกสาร15ลิ้นชัก รุ่น VIO",
                            "NameMM": "VIO Cabinet - 15 Drawers",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-150/M",
                            "NameThai": "โต๊ะทำงาน 5ฟุต 6ลิ้นชัก vio- Modesty",
                            "NameMM": "Working Desk  5FT 6drawers VIO -Modesty part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-150/T",
                            "NameThai": "โต๊ะทำงาน 5ฟุต 6ลิ้นชัก vio- Top",
                            "NameMM": "Working Desk  5FT 6drawers VIO -Top part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-156",
                            "NameThai": "โต๊ะทำงาน 5ฟุต 6ลิ้นชัก vio",
                            "NameMM": "Working Desk  5FT 6drawers VIO",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-156(S)",
                            "NameThai": "โต๊ะทำงาน 5ฟุต 6ลิ้นชัก vio (KD)",
                            "NameMM": "Working Desk  5FT 6drawers VIO (Set)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-156/B (S)",
                            "NameThai": "โต๊ะทำงาน 5ฟุต 6ลิ้นชัก vio มีถาดคีย์บอร์ด (KD)",
                            "NameMM": "Working Desk  5FT 6drawers+KB VIO (Set)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-2122",
                            "NameThai": "ตู้2บานเปิด กลาง vio",
                            "NameMM": "VIO Cabinet M- 2doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-223",
                            "NameThai": "โต๊ะเหล็กVIO 4ลิ้นชัก3.5ฟุตC",
                            "NameMM": "VIO working desk 3.5FT 4Drawers",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-223(S)",
                            "NameThai": "โต๊ะเหล็กVIO 4ลิ้นชัก3.5ฟุตC (KD)",
                            "NameMM": "VIO working desk 3.5FT 4Drawers (set)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-223B",
                            "NameThai": "โต๊ะเหล็กVIO 3ลิ้นชัก3.5ฟุตC +Keyboard",
                            "NameMM": "VIO working desk 3.5FT 3Drawers +Keyboard",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-223B(S)",
                            "NameThai": "โต๊ะเหล็กVIO 3ลิ้นชัก3.5ฟุตC +Keyboard (KD)",
                            "NameMM": "VIO working desk 3.5FT 3Drawers +Keyboard (set)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-288",
                            "NameThai": "ตู้2บานเปิด เล็ก vio",
                            "NameMM": "VIO Cabinet S -2doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-323",
                            "NameThai": "โต๊ะเหล็กVIO 4ลิ้นชัก4ฟุตC",
                            "NameMM": "VIO working desk 4FT 4Drawers",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-323(S)",
                            "NameThai": "โต๊ะเหล็กVIO 4ลิ้นชัก4ฟุตC (KD)",
                            "NameMM": "VIO working desk 4FT 4Drawers (set)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-323B",
                            "NameThai": "โต๊ะเหล็กVIO 3ลิ้นชัก4ฟุตC +Keyboard",
                            "NameMM": "VIO working desk 4FT 3Drawers +Keyboard",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-323B(S)",
                            "NameThai": "โต๊ะเหล็กVIO 3ลิ้นชัก4ฟุตC +Keyboard (KD)",
                            "NameMM": "VIO working desk 4FT 3Drawers +Keyboard (set)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-503",
                            "NameThai": "ตู้เสริมข้างโต๊ะ3ลิ้นชักมีล้อเลื่อน vio BS-503",
                            "NameMM": "VIO 3 Drawers Pedestal with caster",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-703",
                            "NameThai": "ตู้เสริมข้างโต๊ะ3ลิ้นชัก vio",
                            "NameMM": "VIO 3 Drawers Pedestal",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-856",
                            "NameThai": "โต๊ะเหล็กVIO 7ลิ้นชัก4.5ฟุตC",
                            "NameMM": "VIO working desk 5FT 7Drawers",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-856(S)",
                            "NameThai": "โต๊ะเหล็กVIO 7ลิ้นชัก4.5ฟุตC (KD)",
                            "NameMM": "VIO working desk 5FT 7Drawers (set)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-856B",
                            "NameThai": "โต๊ะเหล็กVIO 6ลิ้นชัก4.5ฟุตC +Keyboard",
                            "NameMM": "VIO working desk 5FT 6Drawers +Keyboard",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-856B(S)",
                            "NameThai": "โต๊ะเหล็กVIO 6ลิ้นชัก4.5ฟุตC +Keyboard (KD)",
                            "NameMM": "VIO working desk 5FT 6Drawers +Keyboard (set)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-940",
                            "NameThai": "ตู้เก็บเอกสาร10ลิ้นชัก รุ่น VIO",
                            "NameMM": "VIO Cabinet - 10 Drawers",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-956",
                            "NameThai": "โต๊ะเหล็กVIO 7ลิ้นชัก5ฟุตC",
                            "NameMM": "VIO working desk 5FT 7Drawers",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-956(S)",
                            "NameThai": "โต๊ะเหล็กVIO 7ลิ้นชัก5ฟุตC (KD)",
                            "NameMM": "VIO working desk 5FT 7Drawers (set)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-956B",
                            "NameThai": "โต๊ะเหล็กVIO 6ลิ้นชัก5ฟุตC +Keyboard",
                            "NameMM": "VIO working desk 5FT 6Drawers +Keyboard",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-956B(S)",
                            "NameThai": "โต๊ะเหล็กVIO 6ลิ้นชัก5ฟุตC +Keyboard (KD)",
                            "NameMM": "VIO working desk 5FT 6Drawers +Keyboard (set)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-BOX",
                            "NameThai": "BOX VIO ข้าง ขวา (BS-223,323,856,956)",
                            "NameMM": "BOX VIO",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-BOX/L",
                            "NameThai": "BOX VIO ข้าง ซ้าย (BS-856,956)",
                            "NameMM": "BOX VIO",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-Mod223",
                            "NameThai": "Mod BS-223",
                            "NameMM": "Mod BS-223",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-Mod223B",
                            "NameThai": "Mod BS-223 ถาดคีย์บอร์ด",
                            "NameMM": "Mod BS-223 +Keyboard tray",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-Mod323",
                            "NameThai": "Mod BS-323",
                            "NameMM": "Mod BS-323",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-Mod323B",
                            "NameThai": "Mod BS-323 +keyboard",
                            "NameMM": "Mod BS-323 +keyboard tray",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-Mod856",
                            "NameThai": "Mod BS-856",
                            "NameMM": "Mod BS-856",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-Mod856B",
                            "NameThai": "Mod BS-856B มีถาดคีย์บอร์ด",
                            "NameMM": "Mod BS-856 +keyboard tray",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-Mod956",
                            "NameThai": "Mod BS-956",
                            "NameMM": "Mod BS-956",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-Mod956B",
                            "NameThai": "Mod BS-956B",
                            "NameMM": "Mod BS-956 +keyboard tray",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-T123",
                            "NameThai": "Top BS-123",
                            "NameMM": "Top BS-123",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-T156",
                            "NameThai": "Top BS-156",
                            "NameMM": "Top BS-156",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-T223",
                            "NameThai": "Top BS-223",
                            "NameMM": "Top BS-223",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-T323",
                            "NameThai": "Top BS-323",
                            "NameMM": "Top BS-323",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-T856",
                            "NameThai": "Top BS-856",
                            "NameMM": "Top BS-856",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BS-T956",
                            "NameThai": "Top BS-956",
                            "NameMM": "Top BS-956",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BV-01",
                            "NameThai": "โต๊ะทำงานขาเอียง BV-01",
                            "NameMM": "Folding table -v legs",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BV-01(S)",
                            "NameThai": "โต๊ะทำงานขาเอียง BV-01",
                            "NameMM": "Folding table -v legs (set)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BV-01/B",
                            "NameThai": "โต๊ะทำงานขาเอียง BV-01 ตู้บน",
                            "NameMM": "Folding table -v legs /Box part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BV-01/L",
                            "NameThai": "โต๊ะทำงานขาเอียง BV-01 ขาตั้ง",
                            "NameMM": "Folding table -v legs /Leg part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BV-02",
                            "NameThai": "ตู้เสริม BV-02",
                            "NameMM": "Topup Cabinet for Folding table -v legs",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BV-11N",
                            "NameThai": "โต๊ะเด็ก BV-11",
                            "NameMM": "Small Table -v legs",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BW-01",
                            "NameThai": "ตู้เสื้อผ้า สูง 2 เมตร 2 บานทึบ",
                            "NameMM": "BRIM Wardrobe 2m -sliding door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BW-01(S)",
                            "NameThai": "ตู้เสื้อผ้า2แบบใหม่ สูง 2 เมตร KD ซ้ายทึบ ขวาทึบ",
                            "NameMM": "BRIM Wardrobe 2m -sliding door (set)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BW-01/B",
                            "NameThai": "ตู้เสื้อผ้า2 รุ่นใหม่ (กล่อง BODY) สูง 2 เมตร",
                            "NameMM": "BRIM Wardrobe 2m -sliding door /Body part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BW-01/D",
                            "NameThai": "ตู้เสื้อผ้า2 รุ่นใหม่ (กล่อง DOOR) ซ้ายทึบ ขวาทึบ สูง 2 เมตร",
                            "NameMM": "BRIM Wardrobe 2m -sliding door /Door part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BW-01/F",
                            "NameThai": "ตู้เสื้อผ้า2 รุ่นใหม่ (กล่อง Frame) สูง  2 เมตร",
                            "NameMM": "BRIM Wardrobe 2m -sliding door /Frame part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BW-02",
                            "NameThai": "ตู้เสื้อผ้า สูง 2 เมตร 1 บานทีบ 1 บานกระจกเงา",
                            "NameMM": "BRIM Wardrobe 2m -sliding door, 1mirror",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BW-02(S)",
                            "NameThai": "ตู้เสื้อผ้า2แบบใหม่ สูง 2 เมตร KD ซ้ายทึบ ขวากระจกเงา",
                            "NameMM": "BRIM Wardrobe 2m -sliding door, 1mirror (set)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BW-02/D",
                            "NameThai": "ตู้เสื้อผ้า2 รุ่นใหม่ (กล่อง DOOR) ซ้ายทึบ ขวากระจกเงา สูง 2 เมตร",
                            "NameMM": "BRIM Wardrobe 2m -sliding door, 1mirror /Door part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BW-02/F",
                            "NameThai": "ตู้เสื้อผ้า2 รุ่นใหม่ (กล่อง Frame) สูง 2 เมตร",
                            "NameMM": "BRIM Wardrobe 2m -sliding door, 1mirror /Frame part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BW-03",
                            "NameThai": "ตู้เสื้อผ้า สูง 1.7 เมตร 2 บานทึบ",
                            "NameMM": "BRIM Wardrobe 1.7m with Base -sliding door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BW-03(S)",
                            "NameThai": "ตู้เสื้อผ้า2แบบใหม่ สูง 2 เมตร KD ซ้ายทึบ ขวาทึบ+ฐานรอง",
                            "NameMM": "BRIM Wardrobe 1.7m with Base -sliding door (set)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BW-03/B",
                            "NameThai": "ตู้เสื้อผ้า2 รุ่นใหม่ (กล่อง BODY) สูง 1.7 เมตร",
                            "NameMM": "BRIM Wardrobe 1.7m with Base -sliding door /Body part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BW-03/D",
                            "NameThai": "ตู้เสื้อผ้า2 รุ่นใหม่ (กล่อง DOOR) ซ้ายทึบ ขวาทึบ สูง 1.7 เมตร",
                            "NameMM": "BRIM Wardrobe 1.7m with Base -sliding door /Door part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BW-03/F",
                            "NameThai": "ตู้เสื้อผ้า2 รุ่นใหม่ (กล่อง Frame) สูง  1.7 เมตร",
                            "NameMM": "BRIM Wardrobe 1.7m with Base -sliding door /Frame part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BW-04",
                            "NameThai": "ตู้เสื้อผ้า สูง 1.7 เมตร 1 บานทึบ 1 บานกระจกเงา",
                            "NameMM": "BRIM Wardrobe 1.7m with Base -sliding door, 1mirror",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BW-04(S)",
                            "NameThai": "ตู้เสื้อผ้า2แบบใหม่ สูง 2 เมตร KD ซ้ายทึบ ขวากระจกเงา+ฐานรอง",
                            "NameMM": "BRIM Wardrobe 1.7m with Base -sliding door, 1mirror (set)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BW-04/D",
                            "NameThai": "ตู้เสื้อผ้า2 รุ่นใหม่ (กล่อง DOOR) ซ้ายทึบ ขวากระจกเงา สูง 1.7 เมตร",
                            "NameMM": "BRIM Wardrobe 1.7m with Base -sliding door, 1mirror /Door part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "BWD-01",
                            "NameThai": "ลิ้นชัก BW",
                            "NameMM": "BRIM additional Drawer for wardrobe",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "DB-101",
                            "NameThai": "ตู้ครัวเล็ก 2ลิ้นชัก",
                            "NameMM": "Dobbel Kitchen small cabinet Stanless top -1drawer, 1door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "DB-102",
                            "NameThai": "ตู้ครัวเล็ก 2บานเปิด",
                            "NameMM": "Dobbel Kitchen small cabinet Stanless top -2doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "DB-201",
                            "NameThai": "ตู้ครัวใหญ่ 2บานเปิด DB-201",
                            "NameMM": "Dobbel Kitchen cabinet Stanless top -2doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "DB-202",
                            "NameThai": "ตู้ครัวใหญ่ 2ลิ้นชัก วางเตาแก๊ส DB-202",
                            "NameMM": "Dobbel Kitchen cabinet Stanless top -2drawers 2doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "DB-203",
                            "NameThai": "ตู้ครัวใหญ่ 2บานเปิดวางซิงค์",
                            "NameMM": "Dobbel Kitchen cabinet Stanless top -2doors with Sink",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "DB-203/L",
                            "NameThai": "ตู้ครัวใหญ่ 2บานเปิดวางซิงค์ หลุมอยู่ซ้าย",
                            "NameMM": "Dobbel Kitchen cabinet Stanless top -2doors with Left Sink",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "DB-203/R",
                            "NameThai": "ตู้ครัวใหญ่ 2บานเปิดวางซิงค์ หลุมอยู่ขวา",
                            "NameMM": "Dobbel Kitchen cabinet Stanless top -2doors with Right Sink",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "DB-301",
                            "NameThai": "ตู้ครัวแขวนเล็ก1บานเปิด",
                            "NameMM": "Dobbel hanging cabinet  -1door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "DB-302",
                            "NameThai": "ตู้ครัวแขวนใหญ่2บานเปิด",
                            "NameMM": "Dobbel hanging cabinet  -2doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "DCL-2",
                            "NameThai": "ตู้2บานประตูมือจับเขาควาย",
                            "NameMM": "2 Doors Cabinet -L handle lock",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "DCL-2K",
                            "NameThai": "ตู้2บานประตูมือจับเขาควาย KD",
                            "NameMM": "2 Doors Cabinet -L handle lock KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "DCR-2",
                            "NameThai": "ตู้2บานประตูมือจับฝัง",
                            "NameMM": "2 Doors Cabinet -flush handle lock",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "DCR-2K",
                            "NameThai": "ตู้2บานประตูมือจับฝัง KD",
                            "NameMM": "2 Doors Cabinet -flush handle lock KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "DH-50",
                            "NameThai": "ตู้เซฟกันไฟแนวนอน ระบบหมุนรหัส",
                            "NameMM": "Safebox 50kg -Horizontal Dial Lock",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "DH-50E",
                            "NameThai": "ตู้เซฟกันไฟแนวนอน ระบบดิจิตอล",
                            "NameMM": "Safebox 50kg -Horizontal Digital Lock",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "DISPLAY-01",
                            "NameThai": "9 ITEMS + DISPLAY",
                            "NameMM": "9 ITEMS + DISPLAY",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "DV-100",
                            "NameThai": "ตู้เซฟกันไฟแนวตั้ง ระบบหมุนรหัส 150กก",
                            "NameMM": "Safebox 150kg -Vertical Dial Lock",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "DV-100E",
                            "NameThai": "ตู้เซฟกันไฟแนวตั้ง ระบบดิจิตอล 150กก",
                            "NameMM": "Safebox 150kg -Vertical Digital Lock",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "DV-50",
                            "NameThai": "ตู้เซฟกันไฟแนวตั้ง ระบบหมุนรหัส",
                            "NameMM": "Safebox 50kg -Vertical Dial Lock",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "DV-50E",
                            "NameThai": "ตู้เซฟกันไฟแนวตั้ง ระบบดิจิตอล",
                            "NameMM": "Safebox 50kg -Vertical Digital Lock",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ELK-1",
                            "NameThai": "ตู้ล๊อกเกอร์เล็ก 1บานประตู",
                            "NameMM": "Locker -1door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ELK-1K",
                            "NameThai": "ตู้ล๊อกเกอร์Knockdown 1ประตู",
                            "NameMM": "Locker -1door KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ELK-2",
                            "NameThai": "ตู้ล๊อกเกอร์เล็ก 2ประตู",
                            "NameMM": "Locker -2doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ELK-2K",
                            "NameThai": "ตู้ล๊อกเกอร์Knockdown 2ประตู",
                            "NameMM": "Locker -2doors KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ELK-3",
                            "NameThai": "ตู้ล๊อกเกอร์เล็ก 3ประตู",
                            "NameMM": "Locker -3doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ELK-3K",
                            "NameThai": "ตู้ล๊อกเกอร์Knockdown 3ประตู",
                            "NameMM": "Locker -3doors KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ELK-4",
                            "NameThai": "ตู้ล๊อกเกอร์เล็ก 4ประตู",
                            "NameMM": "Locker -4doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ELK-4K",
                            "NameThai": "ตู้ล๊อกเกอร์Knockdown 4ประตู",
                            "NameMM": "Locker -4doors KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ELK-6",
                            "NameThai": "ตู้ล๊อกเกอร์เล็ก 6ประตู",
                            "NameMM": "Locker -6doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ELK-6K",
                            "NameThai": "ตู้ล๊อกเกอร์Knockdown 6ประตู",
                            "NameMM": "Locker -6doors KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "FA-1319",
                            "NameThai": "ตู้เก็บเอกสาร15ลิ้นชัก(ใหญ่)มือจับฝัง",
                            "NameMM": "Cabinet - 15 Drawers",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "FA-940",
                            "NameThai": "ตู้เก็บเอกสาร10ลิ้นชัก(ใหญ่)มือจับฝัง",
                            "NameMM": "Cabinet - 10 Drawers",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "HD-100",
                            "NameThai": "ตู้แขวน1บานเปิดบน HD-100",
                            "NameMM": "Hanging Cabinet 100cm 1door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "HD-40",
                            "NameThai": "ตู้แขวน1บานเปิดบน HD-40",
                            "NameMM": "Hanging Cabinet 40cm 1door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "HD-80",
                            "NameThai": "ตู้แขวน1บานเปิดบน HD-80",
                            "NameMM": "Hanging Cabinet 80cm 1door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "HDR-100",
                            "NameThai": "ตู้แขวน 2 ลิ้นชัก HDR-100",
                            "NameMM": "Hanging Cabinet 100cm 2drawers",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "HDR-40",
                            "NameThai": "ตู้แขวน 1 ลิ้นชัก HDR-40",
                            "NameMM": "Hanging Cabinet 400cm 1drawer",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "HDR-80",
                            "NameThai": "ตู้แขวน 2 ลิ้นชัก HDR-80",
                            "NameMM": "Hanging Cabinet 80cm 2drawers",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "HF-2",
                            "NameThai": "ตู้เอกสารแฟ้มแขวน2ลิ้นชัก",
                            "NameMM": "Hanging File Cabinet - 2 drawers",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "HF-2K",
                            "NameThai": "ตู้เอกสารแฟ้มแขวน2ลิ้นชัก(Anti-Tilt)KD",
                            "NameMM": "Hanging File Cabinet - 2 drawers KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "HF-3",
                            "NameThai": "ตู้เอกสารแฟ้มแขวน3ลิ้นชัก",
                            "NameMM": "Hanging File Cabinet - 3 drawers",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "HF-3K",
                            "NameThai": "ตู้เอกสารแฟ้มแขวน3ลิ้นชัก(Anti-Tilt)KD",
                            "NameMM": "Hanging File Cabinet - 3 drawers KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "HF-4",
                            "NameThai": "ตู้เอกสารแฟ้มแขวน4ลิ้นชัก",
                            "NameMM": "Hanging File Cabinet - 4 drawers",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "HF-4K",
                            "NameThai": "ตู้เอกสารแฟ้มแขวน4ลิ้นชัก(Anti-Tilt)KD",
                            "NameMM": "Hanging File Cabinet - 4 drawers KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "HO-100",
                            "NameThai": "ตู้แขวนโล่ง HO-100",
                            "NameMM": "Hanging Cabinet 100cm",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "HO-40",
                            "NameThai": "ตู้แขวนโล่ง HO-40",
                            "NameMM": "Hanging Cabinet 40cm",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "HO-80",
                            "NameThai": "ตู้แขวนโล่ง HO-80",
                            "NameMM": "Hanging Cabinet 80cm",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "HOD-100",
                            "NameThai": "ตู้แขวน1บานเปิด,1ชั้นวาง HOD-100",
                            "NameMM": "Hanging Cabinet 100cm 1door1shelf",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "HOD-40",
                            "NameThai": "ตู้แขวน1บานเปิด,1ชั้นวาง HOD-40",
                            "NameMM": "Hanging Cabinet 40cm 1door1shelf",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "HOD-80",
                            "NameThai": "ตู้แขวน1บานเปิด,1ชั้นวาง HOD-80",
                            "NameMM": "Hanging Cabinet 80cm 1door1shelf",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KGD-05",
                            "NameThai": "ตู้เสื้อผ้า 1 บานกระจกเงา ตู้เชื่อม",
                            "NameMM": "KOL Wardrobe - 2 sliding doors,1mirror",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KGD-17",
                            "NameThai": "ตู้บานเลื่อนกระจกสูง รุ่นใหม่ (ประหยัด)",
                            "NameMM": "KOL Cabinet -2 sliding glass doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KGD-3",
                            "NameThai": "ตู้บานเลื่อนกระจก ขนาด 3 ฟุต",
                            "NameMM": "KOL Cabinet 3FT -2 sliding glass doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KGD-4",
                            "NameThai": "ตู้บานเลื่อนกระจก ขนาด 4 ฟุต",
                            "NameMM": "KOL Cabinet 4FT -2 sliding glass doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KN-101",
                            "NameThai": "Konner Desk",
                            "NameMM": "Konner Desk",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KN-101(S)",
                            "NameThai": "Konner Desk (KD)",
                            "NameMM": "Konner Desk (set)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KN-101/ST",
                            "NameThai": "Konner Desk -STAND",
                            "NameMM": "Konner Desk /Stand part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KN-101/T",
                            "NameThai": "Konner Desk -Top",
                            "NameMM": "Konner Desk /Top part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KN-102",
                            "NameThai": "Konner Side Desk",
                            "NameMM": "Konner Side Desk",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KN-103",
                            "NameThai": "Konner Pedestal",
                            "NameMM": "Konner Pedestal",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KND-3",
                            "NameThai": "ตู้หนังสือโล่ง ขนาด 3 ฟุต",
                            "NameMM": "Book cabinet 3ft",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KND-4",
                            "NameThai": "ตู้หนังสือโล่ง ขนาด 4 ฟุต",
                            "NameMM": "Book cabinet 4ft",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KOD-05",
                            "NameThai": "ตู้เสื้อผ้า บานทึบ ตู้เชื่อม",
                            "NameMM": "KOL Wardrobe - 2 sliding doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KOD-17",
                            "NameThai": "ตู้บานเลื่อนทึบสูง รุ่นใหม่ (ประหยัด)",
                            "NameMM": "KOL Cabinet -2 sliding doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KOD-3",
                            "NameThai": "ตู้บานเลื่อนทึบ ขนาด 3 ฟุต",
                            "NameMM": "KOL Cabinet 3FT -2 sliding doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KOD-4",
                            "NameThai": "ตู้หนังสือบานเลื่อนทึบ ขนาด 4 ฟุต",
                            "NameMM": "KOL Cabinet 3FT -2 sliding doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KOL05-10",
                            "NameThai": "ฐานรอง KGD-05",
                            "NameMM": "KOL Base for KGD-05",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KU-101",
                            "NameThai": "ตู้ KURVE1 ลิ้นชักสั้น พร้อมล้อเลื่อน และเบาะ",
                            "NameMM": "KURVE short stool with caster",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KU-102",
                            "NameThai": "ตู้ KURVE1 ลิ้นชักยาว พร้อมล้อเลื่อน และเบาะ",
                            "NameMM": "KURVE long stool with caster",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KU-120",
                            "NameThai": "โต๊ะ KURVE 120ซม+กระจก",
                            "NameMM": "KURVE Desk 120cm +glass top",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KU-120(S)",
                            "NameThai": "โต๊ะ KURVE 120ซม+กระจก (KD)",
                            "NameMM": "KURVE Desk 120cm +glass top (set)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KU-120/L",
                            "NameThai": "โต๊ะ KURVE 120ซม - Leg",
                            "NameMM": "KURVE Desk 120cm +glass top /Leg part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KU-120/T",
                            "NameThai": "โต๊ะ KURVE 120ซม - Top",
                            "NameMM": "KURVE Desk 120cm +glass top /Top part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KU-150",
                            "NameThai": "โต๊ะ KURVE 150ซม+กระจก",
                            "NameMM": "KURVE Desk 150cm +glass top",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KU-150(S)",
                            "NameThai": "โต๊ะ KURVE 150ซม+กระจก (KD)",
                            "NameMM": "KURVE Desk 150cm +glass top (set)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KU-150/L",
                            "NameThai": "โต๊ะ KURVE 150ซม - Leg",
                            "NameMM": "KURVE Desk 150cm +glass top /Leg part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KU-150/T",
                            "NameThai": "โต๊ะ KURVE 150ซม - Top",
                            "NameMM": "KURVE Desk 150cm +glass top /Top part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KU-201",
                            "NameThai": "ตู้ KURVE2 ลิ้นชักสั้น พร้อมล้อเลื่อน",
                            "NameMM": "KURVE Cabinet - 2 small drawer with caster",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KU-202",
                            "NameThai": "ตู้ KURVE2 ลิ้นชักยาว พร้อมล้อเลื่อน",
                            "NameMM": "KURVE Cabinet - 2 large drawer with caster",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KU-301",
                            "NameThai": "ตู้ KURVE วางทีวี",
                            "NameMM": "KURVE TV Cabinet",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KU-402",
                            "NameThai": "ตู้ KURVE 2บานเปิด",
                            "NameMM": "KURVE Cabinet - 2doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KU-403",
                            "NameThai": "ตู้ KURVE แขวนผนัง",
                            "NameMM": "KURVE Hanging Cabinet",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KU-404",
                            "NameThai": "ตู้ KURVE แฟ้มแขวน",
                            "NameMM": "KURVE Hanging File Cabinet - 2drawers",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "KU-407",
                            "NameThai": "ตู้ KURVE 7ลิ้นชัก",
                            "NameMM": "KURVE Cabinet -7drawers",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "LB-30",
                            "NameThai": "ตู้ LB-30",
                            "NameMM": "LIBOX Show Case 30cm",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "LB-60",
                            "NameThai": "ตู้ LB-60",
                            "NameMM": "LIBOX Show Case 60cm",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "LB-90",
                            "NameThai": "ตู้ LB-90",
                            "NameMM": "LIBOX Show Case 90cm",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "LT-001",
                            "NameThai": "ตู้วางทีวีบานเลื่อนกระจก-โล่ง",
                            "NameMM": "Lite TV Cabinet",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "LT-002",
                            "NameThai": "ตู้วางทีวีบานเลื่อนกระจก-1ลิ้นชัก",
                            "NameMM": "Lite TV Cabinet 1drawer",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "LT-003",
                            "NameThai": "ตู้แขวนบานเลื่อนกระจก-โล่ง",
                            "NameMM": "Lite Hanging Cabinet",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "LT-004",
                            "NameThai": "ตู้โชว์บานเปิดกระจกสูง",
                            "NameMM": "Lite High Cabinet - 1 glass door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "LT-004K",
                            "NameThai": "ตู้โชว์บานเปิดกระจกสูงKD",
                            "NameMM": "Lite High Cabinet - 1 glass door KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "LT-005",
                            "NameThai": "ตู้โชว์บานเลื่อนกระจกสูง",
                            "NameMM": "Lite High Cabinet - 4 sliding glass doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "LT-006",
                            "NameThai": "ตู้โชว์บานเปิดทึบ 4 บาน",
                            "NameMM": "Lite High Cabinet - 4 swing glass doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-011",
                            "NameThai": "ตู้ MaxBook แขวนทึบ2ประตู",
                            "NameMM": "MaxBook Hanging Cabinet -2doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-011/J",
                            "NameThai": "ตู้ MaxBook แขวนทึบ2ประตู Jigsaw",
                            "NameMM": "MaxBook Hanging Cabinet -2doors /Jigsaw",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-012",
                            "NameThai": "ตู้ MaxBook แขวนกระจก2ประตู",
                            "NameMM": "MaxBook Hanging Cabinet -2 glass doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-021",
                            "NameThai": "ตู้ MaxBook กลางทึบ1ประตู 2ชั้น",
                            "NameMM": "MaxBook 1M Cabinet - 1 door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-021/J",
                            "NameThai": "ตู้ MaxBook กลางทึบ1ประตู 2ชั้น Jigsaw",
                            "NameMM": "MaxBook 1M Cabinet - 1 door /Jigsaw",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-022",
                            "NameThai": "ตู้ MaxBook กลางกระจก1ประตู 2ชั้น",
                            "NameMM": "MaxBook 1M Cabinet - 1glass door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-031",
                            "NameThai": "ตู้ MaxBook กลางทึบ2ประตู 2ชั้น",
                            "NameMM": "MaxBook 1M Cabinet - 2 doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-031/J",
                            "NameThai": "ตู้ MaxBook กลางทึบ2ประตู 2ชั้น Jigsaw",
                            "NameMM": "MaxBook 1M Cabinet - 2 doors /Jigsaw",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-032",
                            "NameThai": "ตู้ MaxBook กลางกระจก2ประตู 2ชั้น",
                            "NameMM": "MaxBook 1M Cabinet - 2 glass doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-033",
                            "NameThai": "ตู้ MaxBook กลางกระจก2ประตู 5ชั้น",
                            "NameMM": "MaxBook 1M Cabinet - 2 glass doors -5shelves",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-034",
                            "NameThai": "ตู้ MaxBook กลางทึบ2ประตู 5ชั้น",
                            "NameMM": "MaxBook 1M Cabinet - 2 doors -5shelves",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-034/J",
                            "NameThai": "ตู้ MaxBook กลางทึบ2ประตู 5ชั้น Jigsaw",
                            "NameMM": "MaxBook 1M Cabinet - 2 doors -5shelves /Jigsaw",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-041",
                            "NameThai": "ตู้ MaxBook สูงทึบ1ประตู 5ชั้น",
                            "NameMM": "MaxBook 2M Cabinet - 1 doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-041/J",
                            "NameThai": "ตู้ MaxBook สูงทึบ1ประตู 5ชั้น Jigsaw",
                            "NameMM": "MaxBook 2M Cabinet - 1 doors /Jigsaw",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-042",
                            "NameThai": "ตู้ MaxBook สูงกระจก1ประตู 5ชั้น",
                            "NameMM": "MaxBook 2M Cabinet - 1 glass doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-051",
                            "NameThai": "ตู้ MaxBook สูงทึบ2ประตู 5ชั้น",
                            "NameMM": "MaxBook 2M Cabinet - 2 doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-051/J",
                            "NameThai": "ตู้ MaxBook สูงทึบ2ประตู 5ชั้น Jigsaw",
                            "NameMM": "MaxBook 2M Cabinet - 2 doors /Jigsaw",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-051K",
                            "NameThai": "ตู้หนังสือ 2 บาน ทึบ MAX-051 KD",
                            "NameMM": "MaxBook 2M Cabinet - 2 doors KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-052",
                            "NameThai": "ตู้ MaxBook สูงกระจก2ประตู 5ชั้น",
                            "NameMM": "MaxBook 2M Cabinet - 2 glass doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-052K",
                            "NameThai": "ตู้หนังสือ 2 บาน กระจก MAX-052 KD",
                            "NameMM": "MaxBook 2M Cabinet - 2 glass doors KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-061",
                            "NameThai": "ตู้สูงวางหนังสือ 6เหลี่ยมสูง บานทึบ",
                            "NameMM": "MaxBook 2M Corner Cabinet - 1 door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-061/J",
                            "NameThai": "ตู้สูงวางหนังสือ 6เหลี่ยมสูง บานทึบ ลาย J",
                            "NameMM": "MaxBook 2M Corner Cabinet - 1 door /Jigsaw",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-062",
                            "NameThai": "ตู้สูงวางหนังสือ 6เหลี่ยมสูง บานกระจก",
                            "NameMM": "MaxBook 2M Corner Cabinet - 1 glass door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-071",
                            "NameThai": "ตู้สูงวางหนังสือ 6เหลี่ยม บานทึบ",
                            "NameMM": "MaxBook 1M Corner Cabinet - 1 door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-071/J",
                            "NameThai": "ตู้สูงวางหนังสือ 6เหลี่ยม บานทึบ ลาย J",
                            "NameMM": "MaxBook 1M Corner Cabinet - 1 door /Jigsaw",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MAX-072",
                            "NameThai": "ตู้สูงวางหนังสือ 6เหลี่ยมเตี้ย บานกระจก",
                            "NameMM": "MaxBook 1M Corner Cabinet - 1 glass door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "MR-6010",
                            "NameThai": "บานกระจกเงา 600*1000",
                            "NameMM": "Hanging Mirror 1m",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ODC-04",
                            "NameThai": "ตู้เสริมตู้เสื้อผ้าบานเปิดทึบ",
                            "NameMM": "Additional cabinet 2 steel doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ODW-12",
                            "NameThai": "ตู้เสื้อผ้าเด็กบานเปิดทึบ",
                            "NameMM": "Kids Wardrobe 2 steel doors 120cm",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ODW-12/B",
                            "NameThai": "ตู้เสื้อผ้าเด็กบานเปิดทึบ หมี",
                            "NameMM": "Kids Wardrobe 2 steel doors 120cm /Bear",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ODW-12/B K",
                            "NameThai": "ตู้เสื้อผ้าเด็ก บานเปิด ลาย หมี KD",
                            "NameMM": "Kids Wardrobe 2 steel doors 120cm /Bear KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ODW-12/N",
                            "NameThai": "ตู้เสื้อผ้าเด็กบานเปิดทึบ ตัวเลข",
                            "NameMM": "Kids Wardrobe 2 steel doors 120cm /Number",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ODW-18",
                            "NameThai": "ตู้เสื้อผ้าบานเปิดทึบ",
                            "NameMM": "Wardrobe 2 steel doors 180cm",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ODW-18/I",
                            "NameThai": "ตู้เสื้อผ้าบานเปิดทึบ ลาย IXY",
                            "NameMM": "Wardrobe 2 steel doors 180cm /Ixy",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ODW-18/IK",
                            "NameThai": "ตู้เสื้อผ้า 2 บาน ทึบ ลาย IXY ODW-18 KD",
                            "NameMM": "Wardrobe 2 steel doors 180cm /Ixy KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ODW-18/U",
                            "NameThai": "ตู้เสื้อผ้าบานเปิดทึบ มีสายU",
                            "NameMM": "Wardrobe 2 steel doors 180cm -u lock",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ODW-18K",
                            "NameThai": "ตู้เสื้อผ้า 2 บาน ทึบ ODW-18 KD",
                            "NameMM": "Wardrobe 2 steel doors 180cm KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "OGW-18",
                            "NameThai": "ตู้เสื้อผ้าบานเปิดกระจก ใส",
                            "NameMM": "Wardrobe 2 glass doors 180cm",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "OGW-18-1",
                            "NameThai": "ตู้เสื้อผ้าบานเปิดกระจก ฝ้า",
                            "NameMM": "Wardrobe 2 frosted glass doors 180cm",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "OGW-18-1K",
                            "NameThai": "ตู้เสื้อผ้าบานเปิดกระจก ฝ้า KD",
                            "NameMM": "Wardrobe 2 frosted glass doors 180cm KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "OGW-18-2",
                            "NameThai": "ตู้เสื้อผ้าบานเปิดกระจก เงา",
                            "NameMM": "Wardrobe 2 mirror glass doors 180cm",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "OGW-18-2K",
                            "NameThai": "ตู้เสื้อผ้าบานเปิดกระจก เงา KD",
                            "NameMM": "Wardrobe 2 mirror glass doors 180cm KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "OGW-18K",
                            "NameThai": "ตู้เสื้อผ้าบานเปิดกระจก ใส KD",
                            "NameMM": "Wardrobe 2 glass doors 180cm KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "Package-A",
                            "NameThai": "SGD-18 *5",
                            "NameMM": "SGD-18 *5",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "Package-B/1",
                            "NameThai": "MAX-052*5",
                            "NameMM": "MAX-052*5",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "Package-B/2",
                            "NameThai": "MAX-052*5 + Ads",
                            "NameMM": "MAX-052*5 + Ads",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "Package-C/01",
                            "NameThai": "WD-05*30",
                            "NameMM": "WD-05*30",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PL-03",
                            "NameThai": "ตู้ล็อคเกอร์ใหญ่ 3 ประตู",
                            "NameMM": "Locker 120cm. 3doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PL-03(S)",
                            "NameThai": "ตู้ล็อกเกอร์ใหญ่ 3 บาน เปิด",
                            "NameMM": "Locker 120cm. 3doors (S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PL-06",
                            "NameThai": "ตู้ล็อคเกอร์ใหญ่ 6 ประตู",
                            "NameMM": "Locker 120cm. 6doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PL-06(S)",
                            "NameThai": "ตู้ล็อกเกอร์ใหญ่ 6 บาน เปิด",
                            "NameMM": "Locker 120cm. 6doors (S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PL-12",
                            "NameThai": "ตู้ล็อคเกอร์ใหญ่ 12 ประตู",
                            "NameMM": "Locker 120cm. 12doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PL-12(S)",
                            "NameThai": "ตู้ล็อกเกอร์ใหญ่ 12 บาน เปิด",
                            "NameMM": "Locker 120cm. 12doors (S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PN-011",
                            "NameThai": "ตู้Pantry บานเปิด1 ประตู+1ลิ้นชัก",
                            "NameMM": "Pantry 1door+1drawer",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PN-101",
                            "NameThai": "ตู้Pantry บานเปิด1 ประตู",
                            "NameMM": "Pantry 1door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PN-201",
                            "NameThai": "ตู้Pantry บานเปิด2 ประตู",
                            "NameMM": "Pantry 2doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PN-401",
                            "NameThai": "ตู้วางซิงค์ 2บานเปิด",
                            "NameMM": "Pantry 2doors with Sink",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PN-501",
                            "NameThai": "ตู้แขวนPantry บานเปิด 2ประตูสูง",
                            "NameMM": "Pantry hanging 2doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PN-502",
                            "NameThai": "ตู้แขวนPantry บานเปิด 2ประตูเตี้ย",
                            "NameMM": "Pantry hanging 2doors small",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PN-503",
                            "NameThai": "ตู้แขวนPantry บานเปิด 1ประตู",
                            "NameMM": "Pantry hanging 1door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PR1003",
                            "NameThai": "กล่องรวมชุดสี",
                            "NameMM": "Color Box - KIOSK",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PT-01",
                            "NameThai": "ตู้เตี้ย Side cabinet -S",
                            "NameMM": "Punto Side cabinet S",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PT-01(S)",
                            "NameThai": "Punto  ตัวเล็ก  (SET)",
                            "NameMM": "Punto Side cabinet S (S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PT-01/B",
                            "NameThai": "ตู้เตี้ย Side cabinet -S (ส่วนโครงตุ้)",
                            "NameMM": "Punto Side cabinet S /Body",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PT-01/L",
                            "NameThai": "ตู้เตี้ย Side cabinet -S (ส่วนขารอง)",
                            "NameMM": "Punto Side cabinet /Leg",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PT-02",
                            "NameThai": "ตู้กลาง  Side cabinet -M",
                            "NameMM": "Punto Side cabinet M",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PT-02(S)",
                            "NameThai": "Punto  ตัวกลาง  (SET)",
                            "NameMM": "Punto Side cabinet M (S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PT-02/B",
                            "NameThai": "ตู้กลาง  Side cabinet -M (ส่วนโครงตู้)",
                            "NameMM": "Punto Side cabinet M /Body",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PT-03",
                            "NameThai": "ตู้วางทีวี TV cabinet",
                            "NameMM": "Punto TV cabinet",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PT-04",
                            "NameThai": "ตู้วางทีวี TV cabinet 150cm",
                            "NameMM": "Punto TV cabinet 150cm",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PT-04(S)",
                            "NameThai": "Punto  ตัวยาว  (SET)",
                            "NameMM": "Punto TV cabinet 150cm (S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PT-04/B",
                            "NameThai": "ตู้วางทีวี TV cabinet 150cm (ส่วนโครงตู้)",
                            "NameMM": "Punto TV cabinet 150cm (S) /Body",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PT-04/L",
                            "NameThai": "ตู้วางทีวี TV cabinet 150cm (ส่วนขารอง)",
                            "NameMM": "Punto TV cabinet 150cm (S) /Leg",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PT-110",
                            "NameThai": "โต๊ะอาหาร PT-110",
                            "NameMM": "Dining Table 110cm",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PT-150",
                            "NameThai": "โต๊ะอาหาร 1500*670*750",
                            "NameMM": "Dining Table 150cm",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PT-60",
                            "NameThai": "ตู้ PT-60",
                            "NameMM": "Punto Living Room table 60",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PT-60C",
                            "NameThai": "Living Room Table with case",
                            "NameMM": "Punto Living Room table 60 +case",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PT-90",
                            "NameThai": "ตู้ PT-90",
                            "NameMM": "Punto Living Room table 90",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PT-90C",
                            "NameThai": "Living Room Table with case",
                            "NameMM": "Punto Living Room table 90 +case",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PTC-60",
                            "NameThai": "ครอบตุ้ PTC-60",
                            "NameMM": "Punto Case for Living Room table 60",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PTC-90",
                            "NameThai": "ครอบตู้ PTC-90",
                            "NameMM": "Punto Case for Living Room table 90",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PW-01",
                            "NameThai": "ตู้แขวนผ้า",
                            "NameMM": "Punto Hanging vertical cabinet",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PW-02",
                            "NameThai": "ตู้แขวน 2 บานเปิด",
                            "NameMM": "Punto Hanging horizontal cabinet",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PW-03",
                            "NameThai": "ตู้เสื้อผ้า 3 บานประตู (ไม่รวมขา)",
                            "NameMM": "Punto Wardrobe 3doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "PW-03(S)",
                            "NameThai": "ตู้เสื่อผ้า ใหญ่ 3 บาน เปิด",
                            "NameMM": "Punto Wardrobe 3doors (S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SDC-04",
                            "NameThai": "ตู้เสริมตู้เสื้อผ้าบานเลื่อนทึบ",
                            "NameMM": "Additional cabinet 2 sliding steel doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SDW-12",
                            "NameThai": "ตู้เสื้อผ้าเด็กบานเลื่อนทึบ",
                            "NameMM": "Kids Wardrobe 2 sliding steel doors 120cm",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SDW-12/B",
                            "NameThai": "ตู้เสื้อผ้าเด็กบานเลื่อนทึบ หมี",
                            "NameMM": "Kids Wardrobe 2 sliding steel doors 120cm /Bear",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SDW-12/B-K",
                            "NameThai": "ตู้เสื้อผ้าเด็กบานเลื่อนทึบ หมี KD",
                            "NameMM": "Kids Wardrobe 2 sliding steel doors 120cm /Bear KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SDW-12/N",
                            "NameThai": "ตู้เสื้อผ้าเด็กบานเลื่อนทึบ ตัวเลข",
                            "NameMM": "Kids Wardrobe 2 sliding steel doors 120cm /Number",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SDW-18",
                            "NameThai": "ตู้เสื้อผ้าบานเลื่อนทึบ",
                            "NameMM": "Wardrobe 2 sliding steel doors 180cm",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SDW-18/I",
                            "NameThai": "ตู้เสื้อผ้าบานเลื่อนทึบ ลาย IXY",
                            "NameMM": "Wardrobe 2 steel doors 180cm /Ixy",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SDW-18/IK",
                            "NameThai": "ตู้เสื้อผ้าบานเลื่อนทึบ ลาย IXY KD",
                            "NameMM": "Wardrobe 2 steel doors 180cm /Ixy KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SDW-18K",
                            "NameThai": "ตู้เสื้อผ้าบานเลื่อนทึบ KD",
                            "NameMM": "Wardrobe 2 steel doors 180cm KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-004-1",
                            "NameThai": "Max book Set #3",
                            "NameMM": "Max book Set #3",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-007",
                            "NameThai": "Konner Set #2 KN-101+KN-102+KN-103+MAX-052",
                            "NameMM": "Konner Set #2 KN-101+KN-102+KN-103+MAX-052",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-009",
                            "NameThai": "PUNTO #2 PT-01+PT02+PT-04",
                            "NameMM": "PUNTO #2 PT-01+PT02+PT-04",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-012-1",
                            "NameThai": "Dobbel Set #2-1",
                            "NameMM": "Dobbel Set #2-1",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-017-1",
                            "NameThai": "Pantio Set2",
                            "NameMM": "Pantio Set2",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-019-1",
                            "NameThai": "Lite Set (LT-001)",
                            "NameMM": "Lite Set (LT-001)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-021",
                            "NameThai": "Duo Shoe Set SW-103 + SW-103",
                            "NameMM": "SW-103 + SW-103",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-022-1",
                            "NameThai": "SGD-18K+ SGD-18K",
                            "NameMM": "SGD-18K+ SGD-18K",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-023",
                            "NameThai": "Duo Book Set #2",
                            "NameMM": "MAX-052 + MAX-052",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-024-1",
                            "NameThai": "Uni Set",
                            "NameMM": "Uni Set",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-026-101",
                            "NameThai": "WDX-05-2K(S) + WD-05-2K(S)",
                            "NameMM": "WDX-05-2K(S) + WD-05-2K(S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-026-18",
                            "NameThai": "WD-05-2N + WD-05-2N",
                            "NameMM": "WD-05-2N + WD-05-2N",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-026-32",
                            "NameThai": "WD-05-1N + WDC-05N",
                            "NameMM": "WD-05-1N + WDC-05N",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-026-34",
                            "NameThai": "WDX-05-2 + WDX-05-2",
                            "NameMM": "WDX-05-2 + WDX-05-2",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-028",
                            "NameThai": "Set MAX-052+BE-035",
                            "NameMM": "MAX-052+BE-035",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-034-1",
                            "NameThai": "MaxBook set #2-1",
                            "NameMM": "MaxBook set #2-1",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-038",
                            "NameThai": "MAX-052+MAX-042+MAX-032+MAX-012",
                            "NameMM": "MAX-052+MAX-042+MAX-032+MAX-012",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-042-6",
                            "NameThai": "OGW-18-2 + ODC-04",
                            "NameMM": "OGW-18-2 + ODC-04",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-045",
                            "NameThai": "SGD-3+SGD-3",
                            "NameMM": "SGD-3+SGD-3",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-046",
                            "NameThai": "SGD-4 + SGD-4",
                            "NameMM": "SGD-4 + SGD-4",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-047",
                            "NameThai": "SOD-3 + SOD-3",
                            "NameMM": "SOD-3 + SOD-3",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-048",
                            "NameThai": "SOD-4 + SOD-4",
                            "NameMM": "SOD-4 + SOD-4",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-048-1",
                            "NameThai": "SGD-4 + SGD-3",
                            "NameMM": "SGD-4 + SGD-3",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-052",
                            "NameThai": "WD-05-2N + HF-3",
                            "NameMM": "SET-052",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-053",
                            "NameThai": "WD-05-2N + FA-1319",
                            "NameMM": "SET-053",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-054",
                            "NameThai": "WD-05-2N + FA-940",
                            "NameMM": "SET-054",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-055",
                            "NameThai": "PW-01 + PW-03",
                            "NameMM": "SET-055",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-056",
                            "NameThai": "AN-01 + AN-02",
                            "NameMM": "SET-056",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-057",
                            "NameThai": "SW-102 * 2",
                            "NameMM": "SET-057",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-058",
                            "NameThai": "SW-103 * 2",
                            "NameMM": "SET-058",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-059",
                            "NameThai": "KN-101 + KN-103",
                            "NameMM": "SET-059",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-060",
                            "NameThai": "LB-30 + LB-60 + LB-90",
                            "NameMM": "SET-060",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-067",
                            "NameThai": "BV-01(S) + BV-02",
                            "NameMM": "BV-01(S) + BV-02",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-068-1",
                            "NameThai": "WD-05-1N + MAX-052",
                            "NameMM": "WD-05-1 + MAX-052",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-068-3",
                            "NameThai": "WD-05-1K+ MAX-052",
                            "NameMM": "WD-05-1K+ MAX-052",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-068-4",
                            "NameThai": "WD-05-2 N+ MAX-052",
                            "NameMM": "WD-05-2N + MAX-052",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-068-6",
                            "NameThai": "WD-05-2K + MAX-052",
                            "NameMM": "WD-05-2K + MAX-052",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-068-8",
                            "NameThai": "WDC-05/AN+ MAX-052",
                            "NameMM": "WDC-05/AN + MAX-052",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-068-9",
                            "NameThai": "WDC-05/AK + MAX-052",
                            "NameMM": "WDC-05/AK+ MAX-052",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-069-1",
                            "NameThai": "WD-05-1N + SGD-18",
                            "NameMM": "WD-05-1N + SGD-18",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-069-2",
                            "NameThai": "WD-05-2N + SGD-18",
                            "NameMM": "WD-05-2N + SGD-18",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-069-3",
                            "NameThai": "WDC-05/AN + SGD-18",
                            "NameMM": "WDC-05/AN+ SGD-18",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-069-4",
                            "NameThai": "WDX-05-2/AN + SGD-18",
                            "NameMM": "WDX-05-2/AN + SGD-18",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-069-5",
                            "NameThai": "WDX-05-2N + SGD-18",
                            "NameMM": "WDX-05-2N + SGD-18",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-070-1",
                            "NameThai": "SGD-18 *5",
                            "NameMM": "SGD-18 *5",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-070-2",
                            "NameThai": "SGD-3 *5",
                            "NameMM": "SGD-3 *5",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-070-3",
                            "NameThai": "SOD-3 *5",
                            "NameMM": "SOD-3 *5",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-070-4",
                            "NameThai": "SGD-4 *5",
                            "NameMM": "SGD-4 *5",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-070-5",
                            "NameThai": "SOD-4 *5",
                            "NameMM": "SOD-4 *5",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-070-6",
                            "NameThai": "WD-05-2N*5",
                            "NameMM": "WD-05-2N*5",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-071",
                            "NameThai": "BV-01 + LT-006",
                            "NameMM": "BV-01 + LT-006",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-072",
                            "NameThai": "SXW-18 + SXW-18/I",
                            "NameMM": "SXW-18 + SXW-18/I",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-073",
                            "NameThai": "BW-01*2",
                            "NameMM": "BW-01*2",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-074",
                            "NameThai": "BW-01 + BW-02",
                            "NameMM": "BW-01 + BW-02",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-075",
                            "NameThai": "BW-03 +  BW-04",
                            "NameMM": "BW-03 + BW-04",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-076",
                            "NameThai": "WD-05-2 N+ SGD-4",
                            "NameMM": "WD-05-2 N+ SGD-4",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-077",
                            "NameThai": "WD-05-2+ MAX-033",
                            "NameMM": "WD-05-2+ SGD-4",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-077N",
                            "NameThai": "WD-05-2N+ MAX-033",
                            "NameMM": "WD-05-2N+ SGD-4",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-078",
                            "NameThai": "WD-05-2 +LT-004",
                            "NameMM": "WD-05-2 + SGD-4",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-078N",
                            "NameThai": "WD-05-2N +LT-004",
                            "NameMM": "WD-05-2N + SGD-4",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-079",
                            "NameThai": "SGD-18(1) + SHF-18(1)",
                            "NameMM": "SGD-18 (1)+ SHF-18 (1)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-080",
                            "NameThai": "MAX-052 (1) + SHF-13 (2)",
                            "NameMM": "MAX-052 (1) + SHF-13 (2)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-081",
                            "NameThai": "WD-05-2 N+DCL-2",
                            "NameMM": "WD-05-2 N+ DCL-2",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-082",
                            "NameThai": "WD-05-2 N+SGD-3",
                            "NameMM": "WD-05-2 N+ SGD-3",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-083-1",
                            "NameThai": "PW-03+BE035",
                            "NameMM": "PW-03+BE035",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-083-2",
                            "NameThai": "PW-03+BE050",
                            "NameMM": "PW-03+BE050",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-083-3",
                            "NameThai": "PW-03+BE060",
                            "NameMM": "PW-03+BE060",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-084-1",
                            "NameThai": "WDC-05/A+BE035",
                            "NameMM": "WDC-05/A+BE035",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-084-1N",
                            "NameThai": "WDC-05/AN+BE035",
                            "NameMM": "WDC-05/AN+BE035",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-084-2",
                            "NameThai": "WD-05-2K+BE035",
                            "NameMM": "WD-05-2K+BE035",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-084-2N",
                            "NameThai": "WD-05-2N+BE035",
                            "NameMM": "WD-05-2N+BE035",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-084-3",
                            "NameThai": "WDX-05-2K+BE035",
                            "NameMM": "WDX-05-2K+BE035",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-085",
                            "NameThai": "WD-02+BE035",
                            "NameMM": "WD-02+BE035",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-086-1",
                            "NameThai": "BW-02+BE035",
                            "NameMM": "BW-02+BE035",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-086-2",
                            "NameThai": "BW-02+BE050",
                            "NameMM": "BW-02+BE050",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-086-3",
                            "NameThai": "BW-02+BE060",
                            "NameMM": "BW-02+BE060",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-087-1",
                            "NameThai": "BE-060+WD-05-2K+WDC-05K",
                            "NameMM": "BE-060+WD-05-2K+WDC-05K",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-087-2",
                            "NameThai": "BE-035+SGW-18-2",
                            "NameMM": "BE-035+SGW-18-2",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-087-3",
                            "NameThai": "BE-050+SGW-18-2",
                            "NameMM": "BE-050+SGW-18-2",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-087-4",
                            "NameThai": "BE-060+SGW-18-2",
                            "NameMM": "BE-060+SGW-18-2",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-087-5",
                            "NameThai": "BE-060+SGW-18-2+SDW-18",
                            "NameMM": "BE-060+SGW-18-2+SDW-18",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-087-6",
                            "NameThai": "BE-035+SXW-18/I",
                            "NameMM": "BE-035+SXW-18/I",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-087-7",
                            "NameThai": "BE-035+WD-05-2K+BV-11",
                            "NameMM": "BE-035+WD-05-2K+BV-11",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-088",
                            "NameThai": "BV-11+MAX-052",
                            "NameMM": "BV-11+MAX-052",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-090-1",
                            "NameThai": "BE-050 + BW-02 + BV-01 + BV-02",
                            "NameMM": "BE-050 + BW-02 + BV-01 + BV-02",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-090-2",
                            "NameThai": "BE-050 + WD-05-2K + BV-01  + BV-02",
                            "NameMM": "BE-050 + WD-05-2K + BV-01  + BV-02",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-090-3",
                            "NameThai": "PT-01 + PT-02 +PT-04 + XX-ACE-02",
                            "NameMM": "PT-01 + PT-02 +PT-04 + XX-ACE-02",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-090-4",
                            "NameThai": "LT-004 + BV-01  + BV-02",
                            "NameMM": "LT-004 + BV-01  + BV-02",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-091",
                            "NameThai": "MR-6010 + BV-11",
                            "NameMM": "MR-6010 + BV-11",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-092",
                            "NameThai": "MAX-052+MAX-042+PT-110",
                            "NameMM": "MAX-052+MAX-042+PT-110",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-093",
                            "NameThai": "PN-501+PN-503+USC-3+UDC-1+UNC-1+USC-1+UNI-1+XX-ACE-01",
                            "NameMM": "PN-501+PN-503+USC-3+UDC-1+UNC-1+USC-1+UNI-1+XX-ACE-01",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-094-1",
                            "NameThai": "SGD-18*10",
                            "NameMM": "SGD-18*10",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-094-2",
                            "NameThai": "SOD-18*10",
                            "NameMM": "SOD-18*10",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-094-3",
                            "NameThai": "SGD-3*10",
                            "NameMM": "SGD-3*10",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-094-4",
                            "NameThai": "SGD-4*10",
                            "NameMM": "SGD-4*10",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-094-5",
                            "NameThai": "SOD-3*10",
                            "NameMM": "SOD-3*10",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-094-6",
                            "NameThai": "SOD-4*10",
                            "NameMM": "SOD-4*10",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-EXPO-1",
                            "NameThai": "BE-035(S) + SH-170 + BV-11N",
                            "NameMM": "BE-035(S) + SH-170 + BV-11N",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-EXPO-1/1",
                            "NameThai": "BE-035(S)  + BV-11N",
                            "NameMM": "BE-035(S) + BV-11N",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-EXPO-10",
                            "NameThai": "WD-05-2 + WD-05-2 + SHF-18",
                            "NameMM": "WD-05-2 + WD-05-2 + SHF-18",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-EXPO-11",
                            "NameThai": "WD-05-2 + SGD-18 + SHF-18",
                            "NameMM": "WD-05-2 + SGD-18 + SHF-18",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-EXPO-12",
                            "NameThai": "SGD-18 + SHF-18(3)",
                            "NameMM": "SGD-18 + SHF-18(3)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-EXPO-13",
                            "NameThai": "WD-05-2 + WDC-05 + BE-035",
                            "NameMM": "WD-05-2 + WDC-05 + BE-035",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-EXPO-14",
                            "NameThai": "PL-06 *3",
                            "NameMM": "PL-06 *3",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-EXPO-2",
                            "NameThai": "SLK-03 + SGD-18+ PT-01",
                            "NameMM": "SLK-03 + SGD-18+PT-01",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-EXPO-3/2",
                            "NameThai": "WD-05-2K(S) + MAX-052",
                            "NameMM": "WD-05-2K(S)  + MAX-052",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-EXPO-3/4",
                            "NameThai": "WDX-05-2K(S) + MAX-052",
                            "NameMM": "WDX-05-2K(S) + MAX-052",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-EXPO-4",
                            "NameThai": "PT-04 + PT-90C",
                            "NameMM": "PT-04 + PT-90C",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-EXPO-5",
                            "NameThai": "PW-03 + PW-02",
                            "NameMM": "PW-03 + PW-02",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-EXPO-6/2",
                            "NameThai": "WD-05-2K(S) + BV-11N",
                            "NameMM": "WD-05-2K(S) + BV-11N",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-EXPO-7",
                            "NameThai": "DB-201+DB-202+DB-301+DB-302",
                            "NameMM": "DB-201+DB-202+DB-301+DB-302",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-EXPO-8",
                            "NameThai": "BE-035 + SGD-18",
                            "NameMM": "BE-035 + SGD-18",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SET-EXPO-9",
                            "NameThai": "MAX-033 + MAX-033",
                            "NameMM": "MAX-033 + MAX-033",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SGC-04",
                            "NameThai": "ตู้เสริมตู้เสื้อผ้าบานเลื่อนกระจก",
                            "NameMM": "Additional cabinet 2 sliding glass doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SGD-120",
                            "NameThai": "ตู้บานเลื่อนกระจก4ฟุต สูง",
                            "NameMM": "Cabinet 4ft 2 sliding glass doors High",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SGD-120(S)",
                            "NameThai": "ตู้บานเลื่อนกระจก4ฟุต สูง+ฐานรอง",
                            "NameMM": "Cabinet 4ft 2 sliding glass doors High +Base (S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SGD-18",
                            "NameThai": "ตู้บานเลื่อนกระจกสูง",
                            "NameMM": "Cabinet 2 sliding glass doors 180cm",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SGD-18KE",
                            "NameThai": "ตู้บานเลื่อนกระจกสูง KD ส่งงานต่างประเทศ",
                            "NameMM": "Cabinet 2 sliding glass doors 180cm KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SGD-18KP(S)",
                            "NameThai": "ตู้บานเลื่อนกระจกสูง 180 แบบKnockdown",
                            "NameMM": "Cabinet 2 sliding glass doors 180cm KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SGD-18KP/B",
                            "NameThai": "ตู้บานเลื่อนกระจกสูง KD  ส่วนโครงตู้ ส่งแบบเป็นกล่อง",
                            "NameMM": "Cabinet 2 sliding glass doors 180cm /Body",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SGD-18KP/D",
                            "NameThai": "ตู้บานเลื่อนกระจกสูง KD  ส่วนบานประตู ส่งแบบเป็นกล่อง",
                            "NameMM": "Cabinet 2 sliding glass doors 180cm /Door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SGD-18KP/F",
                            "NameThai": "ตู้บานเลื่อนกระจกสูง KD  ส่วนเฟรมบน-ล่าง ส่งแบบเป็นกล่อง",
                            "NameMM": "Cabinet 2 sliding glass doors 180cm /Frame",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SGD-3",
                            "NameThai": "ตู้บานเลื่อนกระจก ขนาด 3 ฟุต",
                            "NameMM": "Cabinet 2 sliding glass doors 3ft",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SGD-3K",
                            "NameThai": "ตู้บานเลื่อนกระจก ขนาด 3ฟุตKD",
                            "NameMM": "Cabinet 2 sliding glass doors 3ft KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SGD-4",
                            "NameThai": "ตู้บานเลื่อนกระจก ขนาด 4 ฟุต",
                            "NameMM": "Cabinet 2 sliding glass doors 4ft",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SGD-4K",
                            "NameThai": "ตู้บานเลื่อนกระจก ขนาด 4ฟุตKD",
                            "NameMM": "Cabinet 2 sliding glass doors 4ft KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SGD-5",
                            "NameThai": "ตู้บานเลื่อนกระจก ขนาด 5 ฟุต",
                            "NameMM": "Cabinet 2 sliding glass doors 5ft",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SGW-18",
                            "NameThai": "ตู้เสื้อผ้าบานเลื่อนกระจก",
                            "NameMM": "Wardrobe 2 sliding glass doors 180cm",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SGW-18-1",
                            "NameThai": "ตู้เสื้อผ้าบานเลื่อนกระจก-ฝ้า",
                            "NameMM": "Wardrobe 2 sliding frosted-glass doors 180cm",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SGW-18-1K",
                            "NameThai": "ตู้เสื้อผ้าบานเลื่อนกระจกฝ้า  KD",
                            "NameMM": "Wardrobe 2 sliding frosted-glass doors 180cm KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SGW-18-2",
                            "NameThai": "ตู้เสื้อผ้าบานเลื่อนกระจก-เงา",
                            "NameMM": "Wardrobe 2 sliding mirro doors 180cm",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SGW-18-2K",
                            "NameThai": "ตู้เสื้อผ้าบานเปิด กระจก เงาKD",
                            "NameMM": "Wardrobe 2 sliding mirro doors 180cm KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SGW-18K",
                            "NameThai": "ตู้เสื้อผ้าบานเลื่อนกระจก KD",
                            "NameMM": "Wardrobe 2 sliding glass doors 180cm KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SH-170(S)",
                            "NameThai": "ตู้วางรองเท้า SH-170 (S)",
                            "NameMM": "Shoe cabinet (S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SH-170/B",
                            "NameThai": "ตู้วางรองเท้า SH-170 (ชุดตัวตู้)",
                            "NameMM": "Shoe cabinet /Body",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SH-170/H",
                            "NameThai": "ตู้วางรองเท้า SH-170 (ชุดราวแขวนเสื้อ)",
                            "NameMM": "Shoe cabinet /Hanging",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SH-171",
                            "NameThai": "ตู้วางรองเท้า SH-171",
                            "NameMM": "Shoe cabinet +drawer",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SH-171(S)",
                            "NameThai": "ตู้วางรองเท้า SH-171",
                            "NameMM": "Shoe cabinet +drawer (S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SH-171/B",
                            "NameThai": "ตู้วางรองเท้า SH-171 (ชุดตัวตู้)",
                            "NameMM": "Shoe cabinet +drawer /Body",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-1 P1",
                            "NameThai": "แผ่นชั้นตู้ UNI  Pack1",
                            "NameMM": "Shelf for UNI Pack1",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-1 P2",
                            "NameThai": "แผ่นชั้นตู้ UNI  Pack2",
                            "NameMM": "Shelf for UNI Pack2",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-12 P1",
                            "NameThai": "แผ่นชั้นตู้ MAX รุ่น02,04 Pack1",
                            "NameMM": "Shelf for MAX series02,04 Pack1",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-12 P2",
                            "NameThai": "แผ่นชั้นตู้ MAX รุ่น02,04 Pack2",
                            "NameMM": "Shelf for MAX series02,04 Pack2",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-13 P1",
                            "NameThai": "แผ่นชั้นตู้ MAX รุ่น03,05 Pack1",
                            "NameMM": "Shelf for MAX series03,05 Pack1",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-13 P2",
                            "NameThai": "แผ่นชั้นตู้ MAX รุ่น03,05 Pack2",
                            "NameMM": "Shelf for MAX series03,05 Pack2",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-18 P1",
                            "NameThai": "แผ่นชั้นตู้ บานเลื่อนสูง Pack1",
                            "NameMM": "Shelf for SGD-18 Pack1",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-18 P2",
                            "NameThai": "แผ่นชั้นตู้ บานเลื่อนสูง Pack2",
                            "NameMM": "Shelf for SGD-18 Pack2",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-18 P3",
                            "NameThai": "แผ่นชั้นตู้ บานเลื่อนสูง Pack3 (Temp)",
                            "NameMM": "Shelf for SGD-18 Pack3",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-18 P6",
                            "NameThai": "แผ่นชั้นตู้ บานเลื่อนสูง Pack6 (Temp)",
                            "NameMM": "Shelf for SGD-18 Pack6",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-19 P1",
                            "NameThai": "แผ่นชั้นตู้ เสื้อผ้าบานเลื่อน Pack1",
                            "NameMM": "Shelf for SGW-18 Pack1",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-19 P2",
                            "NameThai": "แผ่นชั้นตู้ เสื้อผ้าบานเลื่อน Pack2",
                            "NameMM": "Shelf for SGW-18 Pack2",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-2 P1",
                            "NameThai": "แผ่นชั้นตู้ UDB Pack1",
                            "NameMM": "Shelf for UDB Pack1",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-2 P2",
                            "NameThai": "แผ่นชั้นตู้ UDB Pack2",
                            "NameMM": "Shelf for UDB Pack2",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-20 P1",
                            "NameThai": "แผ่นชั้นตู้ 2บาน Pack1",
                            "NameMM": "Shelf for DCL,DCR Pack1",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-20 P2",
                            "NameThai": "แผ่นชั้นตู้ 2บาน Pack2",
                            "NameMM": "Shelf for DCL,DCR Pack1",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-21 P1",
                            "NameThai": "แผ่นชั้นตู้ เสื้อผ้าบานเลื่อน Pack1 SXW-18",
                            "NameMM": "Shelf for SXW-18 Pack1",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-3 P1",
                            "NameThai": "แผ่นชั้นตู้ บานเลื่อน3ฟุต Pack1",
                            "NameMM": "Shelf for Cabinet3ft Pack1",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-3 P2",
                            "NameThai": "แผ่นชั้นตู้ บานเลื่อน3ฟุต Pack2",
                            "NameMM": "Shelf for Cabinet3ft Pack2",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-4 P1",
                            "NameThai": "แผ่นชั้นตู้ บานเลื่อน4ฟุต Pack1",
                            "NameMM": "Shelf for Cabinet4ft Pack1",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-4 P2",
                            "NameThai": "แผ่นชั้นตู้ บานเลื่อน4ฟุต Pack2",
                            "NameMM": "Shelf for Cabinet4ft Pack2",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-5 P1",
                            "NameThai": "แผ่นชั้นตู้ บานเลื่อน5ฟุต Pack1",
                            "NameMM": "Shelf for Cabinet5ft Pack1",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-5 P2",
                            "NameThai": "แผ่นชั้นตู้ บานเลื่อน5ฟุต Pack2",
                            "NameMM": "Shelf for Cabinet5ft Pack2",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SHF-WD-2 P1",
                            "NameThai": "แผ่นชั้นตู้ WD-2 Pack1",
                            "NameMM": "Shelf for WD-2 Pack1",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SLK-02",
                            "NameThai": "ตู้บานเปิด SL 2 บานเปิด (KD)",
                            "NameMM": "SLIK Cabinet 2doors KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SLK-03",
                            "NameThai": "ตู้บานเปิด SL 3 บานเปิด (KD)",
                            "NameMM": "SLIK Cabinet 3doors KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SOD-12",
                            "NameThai": "ตู้บานเลื่อนทึบเตี้ย",
                            "NameMM": "Cabinet 4ft 2 sliding steel doors High",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SOD-120",
                            "NameThai": "ตู้บานเลื่อนทึบ4ฟุต สูง",
                            "NameMM": "Cabinet 4ft 2 sliding steel doors High",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SOD-120(S)",
                            "NameThai": "ตู้บานเลื่อนทึบ4ฟุต สูง+ฐานรอง",
                            "NameMM": "Cabinet 4ft 2 sliding steel doors High+Base (S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SOD-18",
                            "NameThai": "ตู้บานเลื่อนทึบสูง",
                            "NameMM": "Cabinet 2 sliding steel doors 180cm",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SOD-18K",
                            "NameThai": "ตู้บานเลื่อนทึบสูง KD",
                            "NameMM": "Cabinet 2 sliding steel doors 180cm KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SOD-18KE",
                            "NameThai": "ตู้บานเลื่อนทึบสูง KD ส่งงานต่างประเทศ",
                            "NameMM": "Cabinet 2 sliding steel doors 180cm KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SOD-3",
                            "NameThai": "ตู้บานเลื่อนทึบ ขนาด 3 ฟุต",
                            "NameMM": "Cabinet 3ft 2 sliding steel doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SOD-3K",
                            "NameThai": "ตู้บานเลื่อนทึบ ขนาด 3ฟุตKD",
                            "NameMM": "Cabinet 3ft 2 sliding steel doors KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SOD-4",
                            "NameThai": "ตู้บานเลื่อนทึบ ขนาด 4 ฟุต",
                            "NameMM": "Cabinet 4ft 2 sliding steel doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SOD-4K",
                            "NameThai": "ตู้บานเลื่อนทึบ ขนาด 4ฟุตKD",
                            "NameMM": "Cabinet 4ft 2 sliding steel doors KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SOD-5",
                            "NameThai": "ตู้บานเลื่อนทึบ ขนาด 5 ฟุต",
                            "NameMM": "Cabinet 5ft 2 sliding steel doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-2436C",
                            "NameThai": "โต๊ะเหล็กอิสระ 4ลิ้นชัก3ฟุตC",
                            "NameMM": "Working Desk 3ft",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-2436C(S)",
                            "NameThai": "โต๊ะเหล็กอิสระ 4ลิ้นชัก3ฟุตC (KD)",
                            "NameMM": "Working Desk 3ft (S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-2436C/B",
                            "NameThai": "Box ST ข้างขวา R ST-2436",
                            "NameMM": "Working Desk 3ft /Box part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-2436C/S",
                            "NameThai": "โต๊ะเหล็กอิสระ 4ลิ้นชัก3ฟุตC Stand",
                            "NameMM": "Working Desk 3ft /Stand part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-2436C/T",
                            "NameThai": "โต๊ะเหล็กอิสระ 4ลิ้นชัก3ฟุตC Top",
                            "NameMM": "Working Desk 3ft /Top part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-2642C",
                            "NameThai": "โต๊ะเหล็กอิสระ4ลิ้นชัก3.5ฟุตC",
                            "NameMM": "Working Desk 3.5ft",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-2642C(S)",
                            "NameThai": "โต๊ะเหล็กอิสระ4ลิ้นชัก3.5ฟุตC (KD)",
                            "NameMM": "Working Desk 3.5ft (S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-2642C/B",
                            "NameThai": "Box ST ข้างขวา R ST-2642,2654,2648,3060",
                            "NameMM": "Working Desk 3.5ft /Box right side",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-2642C/S",
                            "NameThai": "โต๊ะเหล็กอิสระ 4ลิ้นชัก3.5ฟุตC Stand",
                            "NameMM": "Working Desk 3.5ft /Stand part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-2642C/T",
                            "NameThai": "โต๊ะเหล็กอิสระ 4ลิ้นชัก3.5ฟุตC Top",
                            "NameMM": "Working Desk 3.5ft /Top part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-2648C",
                            "NameThai": "โต๊ะเหล็กอิสระ4ลิ้นชัก4ฟุตC",
                            "NameMM": "Working Desk 4ft",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-2648C(S)",
                            "NameThai": "โต๊ะเหล็กอิสระ4ลิ้นชัก4ฟุตC (KD)",
                            "NameMM": "Working Desk 4ft (S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-2648C/S",
                            "NameThai": "โต๊ะเหล็กอิสระ 4ลิ้นชัก4ฟุตC Stand",
                            "NameMM": "Working Desk 4ft /Stand part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-2648C/T",
                            "NameThai": "โต๊ะเหล็กอิสระ 4ลิ้นชัก4ฟุตC Top",
                            "NameMM": "Working Desk 4ft /Top part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-2654C",
                            "NameThai": "โต๊ะเหล็กอิสระ7ลิ้นชัก4.5ฟุตC",
                            "NameMM": "Working Desk 4.5ft",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-2654C(S)",
                            "NameThai": "โต๊ะเหล็กอิสระ7ลิ้นชัก4.5ฟุตC (KD)",
                            "NameMM": "Working Desk 4.5ft (S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-2654C/B",
                            "NameThai": "Box ST ข้างซ้าย L ST-2654,3060",
                            "NameMM": "Working Desk 4.5ft /Box Left side",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-2654C/S",
                            "NameThai": "โต๊ะเหล็กอิสระ 7ลิ้นชัก4.5ฟุตC Stand",
                            "NameMM": "Working Desk 4.5ft /Stand part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-2654C/T",
                            "NameThai": "โต๊ะเหล็กอิสระ 7 ลิ้นชัก4.5ฟุตC Top",
                            "NameMM": "Working Desk 4.5ft /Top part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-3060C",
                            "NameThai": "โต๊ะเหล็กอิสระ7ลิ้นชัก5ฟุตC",
                            "NameMM": "Working Desk 5ft",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-3060C(S)",
                            "NameThai": "โต๊ะเหล็กอิสระ7ลิ้นชัก5ฟุตC (KD)",
                            "NameMM": "Working Desk 5ft (S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-3060C/S",
                            "NameThai": "โต๊ะเหล็กอิสระ 7ลิ้นชัก5ฟุตC Stand",
                            "NameMM": "Working Desk 5ft /Stand part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "ST-3060C/T",
                            "NameThai": "โต๊ะเหล็กอิสระ 7 ลิ้นชัก5ฟุตC Top",
                            "NameMM": "Working Desk 5ft /Top part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SW-102",
                            "NameThai": "ตู้เอนกประสงค์ 2ลิ้นชัก บานสวิง ใหญ่",
                            "NameMM": "Shoe Cabinet 2 swing doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SW-103",
                            "NameThai": "ตู้เอนกประสงค์ 3ลิ้นชัก บานสวิง ใหญ่",
                            "NameMM": "Shoe Cabinet 3 swing doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SXW-18",
                            "NameThai": "ตู้เสื้อผ้าบานเลื่อน รุ่นใหม่ ซ้ายทึบ ขวากระจกเงา",
                            "NameMM": "Wardrobe 1 steel+1 mirror door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SXW-18/I",
                            "NameThai": "ตู้เสื้อผ้าบานเลื่อน รุ่นใหม่ ซ้ายทึบลาย IXY ขวากระจกเงา",
                            "NameMM": "Wardrobe 1 steel/IXY+1 mirror door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SXW-18/IK",
                            "NameThai": "ตู้เสื้อผ้าบานเลื่อน ซ้ายทึบ ลาย IXY  ขวากระจกเงา KD",
                            "NameMM": "Wardrobe 1 steel/IXY+1 mirror door KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SXW-18-2",
                            "NameThai": "ตู้เสื้อผ้าบานเลื่อน รุ่นใหม่ ซ้ายกระจกเงา ขวากระจกเงา",
                            "NameMM": "Wardrobe 2 mirror doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SXW-18-2K",
                            "NameThai": "ตู้เสื้อผ้าบานเลื่อน ซ้ายกระจกเงา  ขวากระจกเงา KD",
                            "NameMM": "Wardrobe 2 mirror doors KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "SXW-18K",
                            "NameThai": "ตู้เสื้อผ้าบานเลื่อน ซ้ายทึบ  ขวากระจกเงา KD",
                            "NameMM": "Wardrobe 1 steel+1 mirror door KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UB-1",
                            "NameThai": "ฐานรองunibox",
                            "NameMM": "Base for UNI, UDB",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UB-2",
                            "NameThai": "ฐานรองUSB",
                            "NameMM": "Base for USB",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UB-4",
                            "NameThai": "ฐานรองตู้บานเลื่อน 4ฟุต โปร่ง",
                            "NameMM": "Base for Cabinet 4ft",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UB-5",
                            "NameThai": "ฐานรองWD เล็ก",
                            "NameMM": "Base for WD1",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UB-5KN",
                            "NameThai": "ฐานรอง UB-5KN",
                            "NameMM": "Base for WD1 KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UB-6",
                            "NameThai": "ฐานรองWD ใหญ่",
                            "NameMM": "Base for WD2",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UB-6K",
                            "NameThai": "ฐานรองWD ใหญ่ KD",
                            "NameMM": "Base for WD2 KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UB-6KN",
                            "NameThai": "ฐานรอง UB-6KN",
                            "NameMM": "Base for WD2 KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UB-7",
                            "NameThai": "ฐานรอง PW",
                            "NameMM": "Base for PW",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UDB-1",
                            "NameThai": "ตู้2ชั้น บานเปิดทึบ 2แผ่นชั้น",
                            "NameMM": "UDB Cabinet +steel door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UDB-2",
                            "NameThai": "ตู้2ชั้น บานเปิดกระจก 2แผ่นชั้น",
                            "NameMM": "UDB Cabinet +glass door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UDC-1/B",
                            "NameThai": "ตู้2ชั้น บานเปิดทึบ 2แผ่นชั้น หมี",
                            "NameMM": "UDB Cabinet +steel door /Bear",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UDC-1/C",
                            "NameThai": "ตู้2ชั้น บานเปิดทึบ 2แผ่นชั้น Circle",
                            "NameMM": "UDB Cabinet +steel door /Circle",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UDC-1/J",
                            "NameThai": "ตู้2ชั้น บานเปิดทึบ 2แผ่นชั้น Jigsaw",
                            "NameMM": "UDB Cabinet +steel door /Jigsaw",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UDC-1/M",
                            "NameThai": "ตู้2ชั้น บานเปิดทึบ 2แผ่นชั้น Magenta",
                            "NameMM": "UDB Cabinet +steel door /Magenta",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UDC-1/N",
                            "NameThai": "ตู้2ชั้น บานเปิดทึบ 2แผ่นชั้น ตัวเลข",
                            "NameMM": "UDB Cabinet +steel door /Number",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UDC-1/R",
                            "NameThai": "ตู้2ชั้น บานเปิดทึบ 2แผ่นชั้น Retro",
                            "NameMM": "UDB Cabinet +steel door /Retro",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UDC-1/V",
                            "NameThai": "ตู้2ชั้น บานเปิดทึบ 2แผ่นชั้น Vintage",
                            "NameMM": "UDB Cabinet +steel door /Vintage",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UNC-1/B",
                            "NameThai": "ตู้วางของบานทึบ หมี",
                            "NameMM": "UNI Cabinet +steel door /Bear",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UNC-1/C",
                            "NameThai": "ตู้วางของบานทึบ Circle",
                            "NameMM": "UNI Cabinet +steel door/Circle",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UNC-1/J",
                            "NameThai": "ตู้วางของบานทึบ Jigsaw",
                            "NameMM": "UNI Cabinet +steel door /Jigsaw",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UNC-1/M",
                            "NameThai": "ตู้วางของบานทึบ Magenta",
                            "NameMM": "UNI Cabinet +steel door /Magenta",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UNC-1/N",
                            "NameThai": "ตู้วางของบานทึบ ตัวเลข",
                            "NameMM": "UNI Cabinet +steel door /Number",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UNC-1/R",
                            "NameThai": "ตู้วางของบานทึบ Retro",
                            "NameMM": "UNI Cabinet +steel door /Retro",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UNC-1/V",
                            "NameThai": "ตู้วางของบานทึบ Vintage",
                            "NameMM": "UNI Cabinet +steel door /Vintage",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UNI-1",
                            "NameThai": "ตู้วางของบานเปิดทึบ",
                            "NameMM": "UNI Cabinet +steel door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UNI-2",
                            "NameThai": "ตู้วางของบานเปิดกระจก",
                            "NameMM": "UNI Cabinet +glass door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UNI-3",
                            "NameThai": "ตู้วางของโล่ง 1 แผ่นชั้น",
                            "NameMM": "UNI Cabinet +no door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "UNI-4",
                            "NameThai": "ตู้2ลิ้นชักเล็ก ไม่มีกุญแจ",
                            "NameMM": "UNI cabit 2drawers",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USB-1",
                            "NameThai": "ตู้บานเลื่อนทึบเตี้ย3ฟุต",
                            "NameMM": "USB Cabinet 2 sliding steel doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USB-2",
                            "NameThai": "ตู้บานเลื่อนกระจกเตี้ย3ฟุต",
                            "NameMM": "USB Cabinet 2 sliding glass doors",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USB-3",
                            "NameThai": "ตู้เตี้ยโล่ง",
                            "NameMM": "USB Cabinet - no door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USB-4",
                            "NameThai": "ตู้2ลิ้นชักเตี้ย",
                            "NameMM": "USB Cabinet 2 drawers",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USC-1/B",
                            "NameThai": "ตู้บานเลื่อนทึบเตี้ย3ฟุต หมี",
                            "NameMM": "USB Cabinet 2 sliding steel doors /Bear",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USC-1/C",
                            "NameThai": "ตู้บานเลื่อนทึบเตี้ย3ฟุต Circle",
                            "NameMM": "USB Cabinet 2 sliding steel doors /Circle",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USC-1/J",
                            "NameThai": "ตู้บานเลื่อนทึบเตี้ย3ฟุต  Jigsaw",
                            "NameMM": "USB Cabinet 2 sliding steel doors /Jigsaw",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USC-1/M",
                            "NameThai": "ตู้บานเลื่อนทึบเตี้ย3ฟุต Magenta",
                            "NameMM": "USB Cabinet 2 sliding steel doors /Magenta",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USC-1/N",
                            "NameThai": "ตู้บานเลื่อนทึบเตี้ย3ฟุต ตัวเลข",
                            "NameMM": "USB Cabinet 2 sliding steel doors /Number",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USC-1/R",
                            "NameThai": "ตู้บานเลื่อนทึบเตี้ย3ฟุต Retro",
                            "NameMM": "USB Cabinet 2 sliding steel doors /Retro",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USC-1/V",
                            "NameThai": "ตู้บานเลื่อนทึบเตี้ย3ฟุต Vintage",
                            "NameMM": "USB Cabinet 2 sliding steel doors /Vintage",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USC-120/C",
                            "NameThai": "ตู้บานเลื่อนทึบสูง4ฟุต Circle",
                            "NameMM": "Cabinet 4ft 2 sliding steel doors High /Circle",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USC-120/M",
                            "NameThai": "ตู้บานเลื่อนทึบสูง4ฟุต Magenta",
                            "NameMM": "Cabinet 4ft 2 sliding steel doors High /Magenta",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USC-120/R",
                            "NameThai": "ตู้บานเลื่อนทึบสูง4ฟุต Retro",
                            "NameMM": "Cabinet 4ft 2 sliding steel doors High /Retro",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USC-3/B",
                            "NameThai": "ตู้บานเลื่อนทึบ3ฟุต หมี",
                            "NameMM": "Cabinet 3ft 2 sliding steel doors /Bear",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USC-3/C",
                            "NameThai": "ตู้บานเลื่อนทึบ3ฟุต Circle",
                            "NameMM": "Cabinet 3ft 2 sliding steel doors /Circle",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USC-3/CK",
                            "NameThai": "ตู้บานเลื่อนทึบ ขนาด 3ฟุตKD ลาย C",
                            "NameMM": "Cabinet 3ft 2 sliding steel doors /Circle KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USC-3/J",
                            "NameThai": "ตู้บานเลื่อนทึบ3ฟุต  Jigsaw",
                            "NameMM": "Cabinet 3ft 2 sliding steel doors /Jigsaw",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USC-3/M",
                            "NameThai": "ตู้บานเลื่อนทึบ3ฟุต Magenta",
                            "NameMM": "Cabinet 3ft 2 sliding steel doors /Magenta",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USC-3/N",
                            "NameThai": "ตู้บานเลื่อนทึบ3ฟุต ตัวเลข",
                            "NameMM": "Cabinet 3ft 2 sliding steel doors /Number",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USC-3/NK",
                            "NameThai": "ตู้บานเลื่อนทึบ ขนาด 3ฟุตKD ลาย N",
                            "NameMM": "Cabinet 3ft 2 sliding steel doors /Number KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USC-3/R",
                            "NameThai": "ตู้บานเลื่อนทึบ3ฟุต Retro",
                            "NameMM": "Cabinet 3ft 2 sliding steel doors /Retro",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USC-3/V",
                            "NameThai": "ตู้บานเลื่อนทึบ3ฟุต Vintage",
                            "NameMM": "Cabinet 3ft 2 sliding steel doors /Vintage",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "USC-3/VK",
                            "NameThai": "ตู้บานเลื่อนทึบ ขนาด 3ฟุตKD ลาย V",
                            "NameMM": "Cabinet 3ft 2 sliding steel doors /Vintage KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WD-01-1",
                            "NameThai": "ตู้เสื้อผ้า1บานเปิด กระจกฝ้า",
                            "NameMM": "WD Wardrobe 1 frosted-glass door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WD-01-1N",
                            "NameThai": "ตู้เสื้อผ้า1บานเปิด กระจกฝ้า พร้อมขา",
                            "NameMM": "WD Wardrobe 1 frosted-glass door+base",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WD-01-2",
                            "NameThai": "ตู้เสื้อผ้า1บานเปิด กระจกเงา",
                            "NameMM": "WD Wardrobe 1 mirror door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WD-01-2N",
                            "NameThai": "ตู้เสื้อผ้า1บานเปิด กระจกเงา รวมขา",
                            "NameMM": "WD Wardrobe 1 mirror door+base",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WD-02-1",
                            "NameThai": "ตู้เสื้อผ้า2บานเปิด กระจกฝ้า",
                            "NameMM": "WD Wardrobe 2 frosted-glass swing door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WD-02-1K",
                            "NameThai": "ตู้เสื้อผ้า2บานเปิด กระจกฝ้า KD",
                            "NameMM": "WD Wardrobe 2 frosted-glass swing door KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WD-02-1N",
                            "NameThai": "ตู้เสื้อผ้า2บานเปิด กระจกฝ้าตู้เชื่อม พร้อมขา",
                            "NameMM": "WD Wardrobe 2 frosted-glass swing door+base",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WD-02-2",
                            "NameThai": "ตู้เสื้อผ้า2บานเปิด กระจกเงา",
                            "NameMM": "WD Wardrobe 2 mirror swing door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WD-02-2K",
                            "NameThai": "ตู้เสื้อผ้า2บานเปิด กระจกเงา KD",
                            "NameMM": "WD Wardrobe 2 mirror swing door KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WD-02-2N",
                            "NameThai": "ตู้เสื้อผ้า2บานเปิด กระจกเงาตู้เชื่อม พร้อมขา",
                            "NameMM": "WD Wardrobe 2 mirror swing door+base",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WD-03-1",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อนเตี้ย กระจกฝ้า",
                            "NameMM": "WD medium Wardrobe 2 frosted-glass sliding door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WD-03-1N",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อนเตี้ย กระจกฝ้า รวมขา",
                            "NameMM": "WD medium Wardrobe 2 frosted-glass sliding door+base",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WD-03-2",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อนเตี้ย กระจกเงา",
                            "NameMM": "WD medium Wardrobe 2 mirror sliding door+base (S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WD-03-2(S)",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อนเตี้ย กระจกเงา+ฐานรอง",
                            "NameMM": "WD medium Wardrobe 2 mirror sliding door+base (S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WD-05-1KP/D",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อน กระจกฝ้า KD กล่องบานประตู",
                            "NameMM": "WD Wardrobe 2 frosted-glass sliding door+base /Door part",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WD-05-2KP/SP/D",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อน กระจกเงามีรูกุญแจ ใส่ในกล่องตู้ ส่งพม่า",
                            "NameMM": "WD Wardrobe 2 mirror sliding door+base /Door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WD-05-2KPT/B",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อน KD กล่องโครงตู้ (KIOSK)",
                            "NameMM": "WD Wardrobe 2 mirror sliding door+base /Body",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WD-05-2KPT/F",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อน KD กล่องคานล่าง (KIOSK)",
                            "NameMM": "WD Wardrobe 2 mirror sliding door+base /Frame",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WD-05-2KPT/SP(S)",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อน กระจกเงาKD บานรูกุญแจ +ฐานรอง(KIOSK) ส่งพม่า",
                            "NameMM": "WD Wardrobe 2 mirror sliding door+base (S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WDC-05/AKP/SP/D",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อน บานทึบสกรีนลาย มีรูกุญแจ ใส่กล่องตู้ ส่งพม่า",
                            "NameMM": "WD Wardrobe 2 screen door+base /Door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WDC-05/AKPT/SP(S)",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อน บานทึบลาย KD บานรูกุญแจ +ฐานรอง KN (KIOSK) ส่งพม่า",
                            "NameMM": "WD Wardrobe 2 screen door+base (S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WDC-05/ASPN",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อนทึบ ลายสกรีน มีกุญแจ ตู้เชื่อม",
                            "NameMM": "Opac Sliding Doors Wardrobe",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WDC-05K(S)",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อนทึบKD+ฐานรอง",
                            "NameMM": "Sliding Opac door Wardrobe KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WDC-05KP SP/D",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อน ทึบ มีรูกุญแจ ใส่ในกล่องตู้ ส่งพม่า",
                            "NameMM": "WD Wardrobe 2 mirror steel door+base /Door",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WDC-05KPT/SP(S)",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อน บานทึบ KD บานรูกุญแจ +ฐานรอง KN (KIOSK) ส่งพม่า",
                            "NameMM": "WD Wardrobe 2 steel door+base (S)",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WDC-05N",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อนทึบตู้เชื่อม พร้อมขา",
                            "NameMM": "Wardrobe With Leg",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WDC-05SPN",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อนทึบตู้เชื่อม พร้อมขา มีกุญแจ",
                            "NameMM": "Wardrobe With Leg",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WDX-05-1/AN",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อน บานทึบลายซ้าย บานกระจกฝ้าขวา ตู้เชื่อม พร้อมขา",
                            "NameMM": "Mix Sliding Door Wardrobe With Leg",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WDX-05-1K(S)",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อนผสมทึบ กระจกฝ้าKD+ฐานรอง",
                            "NameMM": "Sliding MIX Opac Glass door Wardrobe KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WDX-05-1N",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อน บานทึบซ้าย บานกระจกฝ้าขวา ตู้เชื่อม พร้อมขา",
                            "NameMM": "Mix Sliding Door Wardrobe With Leg",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WDX-05-2",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อน บานทึบซ้าย บานกระจกเงาขวา (สลับกันได้) ตู้เชื่อม (ทำเกรด B)",
                            "NameMM": "Mix Sliding Door Wardrobe With Leg",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WDX-05-2/A",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อน บานทึบลายซ้าย บานกระจกเงาขวา ตู้เชื่อม",
                            "NameMM": "Mix Sliding Door Wardrobe",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WDX-05-2/AN",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อน บานทึบลายซ้าย บานกระจกเงาขวา ตู้เชื่อม พร้อมขา",
                            "NameMM": "Mix Sliding Door Wardrobe With Leg",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WDX-05-2K(S)",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อนผสมทึบ กระจกเงาKD+ฐานรอง",
                            "NameMM": "Sliding MIX Opac Mirror door Wardrobe KD",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "WDX-05-2N",
                            "NameThai": "ตู้เสื้อผ้า2บานเลื่อน บานทึบซ้าย บานกระจกเงาขวา ตู้เชื่อม พร้อมขา",
                            "NameMM": "Mix Sliding Door Wardrobe With Leg",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "XX-ACE-01",
                            "NameThai": "ACE Recliner sofa",
                            "NameMM": "ACE Recliner sofa",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "XX-ACE-02",
                            "NameThai": "Sofa -Earth2 ผ้าสีเหลือง 152*79*90*50",
                            "NameMM": "Sofa -Earth2 yellow fabric 152*79*90*50",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "XX-ACE-03",
                            "NameThai": "Sofa -OWEN2S -PU soft สีน้ำตาล",
                            "NameMM": "Sofa -OWEN2S -PU soft brown",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "XX-PN-9053",
                            "NameThai": "เก้าอี้ PIONEER PN9053",
                            "NameMM": "Chair PIONEER PN9053",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "XX-PN-9132/2",
                            "NameThai": "เก้าอี้ PIONEER PN9132/2",
                            "NameMM": "Chair PIONEER PN9132/2",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "XX-PN-9137",
                            "NameThai": "เก้าอี้ PIONEER PN9137",
                            "NameMM": "Chair PIONEER PN9137",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "XX-PN-9213",
                            "NameThai": "เก้าอี้ PIONEER PN9213",
                            "NameMM": "Chair PIONEER PN9213",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "XX-PNG-9171",
                            "NameThai": "เก้าอี้ PIONEER PNG9171",
                            "NameMM": "Chair PIONEER PNG9171",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "XX-PNG-9176",
                            "NameThai": "เก้าอี้ PIONEER PNG9176",
                            "NameMM": "Chair PIONEER PNG9176",
                            "PriceThai": 0,
                            "PriceMM": 0
                        },
                        {
                            "Code": "XX-PP-01",
                            "NameThai": "PP Cabinet set",
                            "NameMM": "PP Cabinet set",
                            "PriceThai": 0,
                            "PriceMM": 0
                        }
                        ],
            
            year: new Date().toISOString().substr(0, 4),
            reYear: new Date().toISOString().substr(0, 4) -1,
            // lastBalance: ''
        }
    },
    methods:{

        uploadCust(){
            // let year = "2018"
            let year = new Date().toISOString().substr(0,4)
            db.collection("customer").get()
            .then(query=>{
                let custDb = []
                query.forEach(doc=>{
                    custDb.push({code: doc.data().code, name: doc.data().name})
                })
                custDb.forEach(rec=>{
                    rec.group = rec.code.substr(0,1)
                    db.collection("custReport").doc(year)
                    .set({
                        [rec.code]:{name: rec.name, group: rec.group, "01": 0, "02": 0, "03": 0, "04": 0, "05": 0, "06": 0, "07": 0, 
                                    "08": 0, "09": 0, "10": 0, "11": 0, "12": 0}
                    }, { merge: true })
                    .then(()=>{
                        console.log(rec.code)
                    })
                })
                // console.log(custDb)
            })
        },
        showAcc(){
            db.collection("chartAccount").get()
            .then(snap=>{
                this.detail = []
                snap.forEach(doc=>{
                    this.detail.push(doc.data())
                })
            })
        },
        upAccChart(){
            let menu =[  
                {
                    "AccountIdentifier": "110001",
                    "AccountName": "Cash on hand",
                    "CashAccount": "Y"
                },
                {
                    "AccountIdentifier": "110002",
                    "AccountName": "Cash for deposit",
                    "CashAccount": "Y"
                },
                {
                    "AccountIdentifier": "110111",
                    "AccountName": "Saving A/C - KBZ-Lek",
                    "CashAccount": "Y"
                },
                {
                    "AccountIdentifier": "110121",
                    "AccountName": "Current A/C -KBZ",
                    "CashAccount": "Y"
                },
                {
                    "AccountIdentifier": "110122",
                    "AccountName": "Current A/C -AYA",
                    "CashAccount": "Y"
                },
                {
                    "AccountIdentifier": "110123",
                    "AccountName": "Current A/C -MCB",
                    "CashAccount": "Y"
                },
                {
                    "AccountIdentifier": "110124",
                    "AccountName": "Current A/C -KBZ FCD",
                    "CashAccount": "Y"
                },
                {
                    "AccountIdentifier": "111001",
                    "AccountName": "Cheque in Transit",
                    "CashAccount": "Y"
                },
                {
                    "AccountIdentifier": "112001",
                    "AccountName": "Accounts Receivable",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "112002",
                    "AccountName": "Cheque returned",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "113301",
                    "AccountName": "Finished Goods",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "119001",
                    "AccountName": "Other receivable",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "119006",
                    "AccountName": "Advance payment",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "119008",
                    "AccountName": "Prepaid expense",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "119009",
                    "AccountName": "Withholding Tax",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "119011",
                    "AccountName": "Purchasing Tax",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "120300",
                    "AccountName": "Building",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "120301",
                    "AccountName": "Accrued Depreciation- building",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "120400",
                    "AccountName": "Building -improvement",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "120401",
                    "AccountName": "Accrued Depreciation- building improvement",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "120500",
                    "AccountName": "Lease",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "120501",
                    "AccountName": "Accrued Depreciation- Lease",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "120700",
                    "AccountName": "Office Equipment",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "120701",
                    "AccountName": "Accrued Depreciation- office equipment",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "120800",
                    "AccountName": "Vehicle",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "120801",
                    "AccountName": "Accrued Depreciation- vehicle",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "130001",
                    "AccountName": "Intangible Asset",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "130002",
                    "AccountName": "Accrued Depreciation- intangible asset",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "131001",
                    "AccountName": "Deposit",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "131011",
                    "AccountName": "Retention",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "210102",
                    "AccountName": "Cheque for payment -KBZ",
                    "CashAccount": "Y"
                },
                {
                    "AccountIdentifier": "210103",
                    "AccountName": "Cheque for payment -AYA",
                    "CashAccount": "Y"
                },
                {
                    "AccountIdentifier": "210104",
                    "AccountName": "Cheque for payment -MCB",
                    "CashAccount": "Y"
                },
                {
                    "AccountIdentifier": "210105",
                    "AccountName": "Cheque for payment -KBZ-FCD",
                    "CashAccount": "Y"
                },
                {
                    "AccountIdentifier": "211001",
                    "AccountName": "Accounts Payable",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "213101",
                    "AccountName": "Accrued expense",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "213201",
                    "AccountName": "Accrued w/h tax",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "213202",
                    "AccountName": "Tax payable",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "213209",
                    "AccountName": "Other Payble",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "214001",
                    "AccountName": "Selling Tax",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "214101",
                    "AccountName": "Deposit received",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "310001",
                    "AccountName": "Capital",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "320001",
                    "AccountName": "Retained Earning",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "320002",
                    "AccountName": "Dividend",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "321001",
                    "AccountName": "Profit and loss for period",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "410001",
                    "AccountName": "Sales-v",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "410002",
                    "AccountName": "Sales-n",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "410101",
                    "AccountName": "Returned and Discount",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "412004",
                    "AccountName": "Interest revenue",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "412009",
                    "AccountName": "Other revenue",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "500101",
                    "AccountName": "Cost of Goods Sold",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "510201",
                    "AccountName": "Cost of Goods Imported",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "510202",
                    "AccountName": "Importing Tax",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "510203",
                    "AccountName": "Freight expense",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "510204",
                    "AccountName": "Other importing expense",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "510209",
                    "AccountName": "Cost of Goods Imported- Being FG",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620100",
                    "AccountName": "Salary- office",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620101",
                    "AccountName": "OT-office",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620103",
                    "AccountName": "Incentive -office",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620104",
                    "AccountName": "Bonus -office",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620105",
                    "AccountName": "Travelling exp -office",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620201",
                    "AccountName": "Telephone expense",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620203",
                    "AccountName": "Internet expense",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620204",
                    "AccountName": "Mailing expense",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620211",
                    "AccountName": "Office supplies",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620213",
                    "AccountName": "Sundry expense",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620221",
                    "AccountName": "Government fee ",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620222",
                    "AccountName": "Bank fee",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620223",
                    "AccountName": "Other fee",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620224",
                    "AccountName": "Audit fee",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620225",
                    "AccountName": "Account fee",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620226",
                    "AccountName": "Counselor fee",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620228",
                    "AccountName": "Rent",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620243",
                    "AccountName": "Bad debt",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620261",
                    "AccountName": "Maintenace expense-office",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620262",
                    "AccountName": "Maintenace expense-vehicle1",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620263",
                    "AccountName": "Maintenace expense-vehicle2",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620264",
                    "AccountName": "Maintenace expense-vehicle3",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620280",
                    "AccountName": "Electricity expense",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620281",
                    "AccountName": "Water expense",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620402",
                    "AccountName": "Gain(Loss) on exchange rate",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "620403",
                    "AccountName": "Gain(Loss) on selling FA",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "621103",
                    "AccountName": "Depreciation exp- building",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "621104",
                    "AccountName": "Depreciation exp- building improvement",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "621105",
                    "AccountName": "Depreciation exp- Lease",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "621107",
                    "AccountName": "Depreciation exp- Office equipment",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "621108",
                    "AccountName": "Depreciation exp- vehicle",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "621111",
                    "AccountName": "Depreciation exp- intangible asset",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "630100",
                    "AccountName": "Salary- Selling dept",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "630101",
                    "AccountName": "OT- Selling dept",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "630103",
                    "AccountName": "Incentive- Selling dept",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "630104",
                    "AccountName": "Bonus- Selling dept",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "630105",
                    "AccountName": "Travelling- Selling dept",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "630108",
                    "AccountName": "Commission",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "630201",
                    "AccountName": "Exhibition expense",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "630204",
                    "AccountName": "Advertising expense",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "630205",
                    "AccountName": "Catalogue expense",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "630301",
                    "AccountName": "Other selling expense",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "631201",
                    "AccountName": "Exhibition expense- Moderntrade",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "631204",
                    "AccountName": "Advertising expense-Moderntrade",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "631301",
                    "AccountName": "Marketing Fee-Pro1",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "631302",
                    "AccountName": "Rebate-Pro1",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "631304",
                    "AccountName": "Adverting -Pro1",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "631309",
                    "AccountName": "Other selling exp-Pro1",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "639100",
                    "AccountName": "Salary -delivery",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "639101",
                    "AccountName": "OT -delivery",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "639103",
                    "AccountName": "Incentive -delivery",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "639104",
                    "AccountName": "Bonus -delivery",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "639105",
                    "AccountName": "Travelling -delivery",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "639111",
                    "AccountName": "Gas expense",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "639112",
                    "AccountName": "Other Delivery expense",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "640100",
                    "AccountName": "Salary -IT",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "640101",
                    "AccountName": "OT -IT",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "640103",
                    "AccountName": "Incentive -IT",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "640104",
                    "AccountName": "Bonus -IT",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "640105",
                    "AccountName": "Travelling -IT",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "690101",
                    "AccountName": "Interest expense",
                    "CashAccount": "N"
                },
                {
                    "AccountIdentifier": "800001",
                    "AccountName": "Corporate Tax",
                    "CashAccount": "N"
                }
            ]

            menu.forEach(function(obj) {
                db.collection("chartAccount").add({
                    accId: obj.AccountIdentifier,
                    accName: obj.AccountName,
                    cash: obj.CashAccount
                }).then(function(docRef) {
                    console.log("Document written with ID: ", docRef.id)
                })
                .catch(function(error) {
                    console.error("Error adding document: ", error)
                })
            })
        },
        upProCode(){
            this.listProd.forEach(objProCode=>{
                // db.collection("code").doc("productcode").collection("test").add({
                db.collection("code").doc("productcode").collection("proCode").add({
                    Code: objProCode.Code,
                    NameThai: objProCode.NameThai,
                    NameMM: objProCode.NameMM,
                    PriceThai: objProCode.PriceThai*1,
                    PriceMM: objProCode.PriceMM*1,
                })
                .then(docProCode=>{
                    console.log("Document written with ID: ", docProCode.id)
                })
            })
        },
        addAcc(){
            // let obj ={a:1,b:2,c:3}
            // console.log(obj.a)
            // console.log(obj["a"])
            // return
            // db.collection("chartAccount").orderBy("accId").get()
            // .then(snapshot=>  {
            //     snapshot.forEach(doc=>{
            //         let accId = doc.data().accId
            //         this.detail.push({accId, balance: 0, jan: 0, feb: 0, mar: 0, apr: 0, may: 0, jun: 0, jul: 0, aug: 0, sep: 0, oct: 0, nov: 0, dec: 0})
            //     })
            // })
            this.detail.forEach(acc=>{
                db.collection("accBalance").doc(this.year)
                // db.collection("accBalance").doc("2020")
                .set({
                    [acc.accId]:{accName: acc.accName, "01": 0, "02": 0, "03": 0, "04": 0, "05": 0, "06": 0, "07": 0, 
                                "08": 0, "09": 0, "10": 0, "11": 0, "12": 0, debit: 0, credit: 0}
                }, { merge: true })
                .then(()=>{
                    console.log(acc.accId)
                })
            })
            
        },

        openInv(){
            db.collection("invoice").where("status", "==", "Cancelled").get()
            .then(query=>{
                let arr = []
                query.forEach(doc=>{
                    arr.push(doc.data().invNo)
                })
                console.log(arr)
            })
        },

        addGl(){
            db.collection("generalLedger").add({
                accId: "410002",
                accName: "Sales-n",
                desc: "Invoice payment",
                debit: 0,
                credit: 232750,
                glNo: "IN190491",
                refNo: "V190033",
                glDate: "2019-09-27",
                remark: "",
            })
            // db.collection("generalLedger").add({
            //     accId: "214101",
            //     accName: "Deposit received",
            //     desc: "Invoice payment",
            //     debit: 0,
            //     credit: 0,
            //     glNo: "IN190491",
            //     refNo: "V190033",
            //     glDate: "2019-09-27",
            //     remark: "",
            // })
            db.collection("generalLedger").add({
                accId: "112001",
                accName: "Accounts Receivable",
                desc: "Invoice payment",
                debit: 232750,
                credit: 0,
                glNo: "IN190491",
                refNo: "V190033",
                glDate: "2019-09-27",
                remark: "",
            })
        },

        test(){
            let newArr = []
            let arrGl = []
            db.collection("generalLedger").where("credit", "==",214900).where("glDate", ">=", "2019-10-01").where("glDate", "<=", "2019-10-31").get()
            .then(query=>{
                query.forEach(doc=>{
                    arrGl.push(doc.data())
                })
                arrGl.sort((a, b) => a.refNo.localeCompare(b.refNo))
                let refNo = null
                let count = 0
                for (let i = 0; i < arrGl.length; i++) {
                    if(arrGl[i].refNo != refNo){
                        if(count > 0){
                            newArr.push({refNo: refNo})
                        }
                        refNo = arrGl[i].refNo
                        count = 1
                    }
                    else{
                        count++
                    }
                }
                if(count > 0){
                    newArr.push({refNo: refNo})
                }
                console.log(newArr)
            })
        },
        searchBalance(){
            let lastYear = new Date().toISOString().substr(0,4) - 1
            let year = new Date().toISOString().substr(0,4)
            let detail = []
            db.collection("accBalance").doc(lastYear.toString()).get()
            .then(doc=>{
                let data = doc.data()
                let key = Object.keys(data)
                key.forEach(rec=>{
                    detail.push({...data[rec],accId:rec})
                })
                detail.forEach(acc=>{
                    db.collection("accBalance").doc(year)
                    .set({
                        [acc.accId]:{accName: acc.accName, "01": 0, "02": 0, "03": 0, "04": 0, "05": 0, "06": 0, "07": 0, 
                                    "08": 0, "09": 0, "10": 0, "11": 0, "12": 0, debit: 0, credit: 0}
                    }, { merge: true })
                    .then(()=>{
                        console.log(acc.accId)
                    })
                })
            })
        }
    },
    mounted(){
        // this.openInv()
        // this.showAcc()
    }
}
</script>
